import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "flatpickr/dist/themes/material_green.css";
import flatpickr from "flatpickr";
import AddFile from "./addfile";
import ContentAccount from "./createcontent";
import { FaEdit, FaCheck, FaTimes } from "react-icons/fa";
import SuccessMail from "./sucessmail";
import Access from "./access";
import AddContent from "./addcontent";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Select, { MultiValue } from "react-select";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import Table from "../../../core/common/dataTable/index";
import { leadsData } from "../../../core/data/json/leads";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import DefaultEditor from "react-simple-wysiwyg";
import { Modal } from 'react-bootstrap';
import { accountType, ascendingandDecending, documentType, LocaleData, selectRelatedToType, selectAssignType, statusList, selectTaskCategoryOptions, selectTaskStatusOptions, selectTaskPriorityOptions, ratingOptions, genderOptions } from "../../../core/common/selectoption/selectoption";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { getLeads, deleteLead, addLead, updateLead, getLeadDetail, updateLeadStatus, getOpportunitiesConvert, getAllContactsConvert } from "./api";
import { createLogCall, deleteLogCall, viewMemberLogCall, updateLogCall, userList, detailLogCall, updateLogCallStatus, listLeadsOption, listContactsOptionn, listAccountsOption, listOpportunitiesOption } from "./logcall_api";
import { createTask, deleteTask, viewMemberTasks, updateTask, detailTask } from "./task_api";
import { createEvent, ViewMemberEvent, deleteEvent, getEventDetail, updateEvent } from "./event_api";
import { useParams } from "react-router-dom";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { TagsInput } from "react-tag-input-component";
import { getTypePipeline } from "../pipeline/pipelineAPI";
import ResponseModal from "../../../core/modals/response_modal";
import {
  countryoptions1,
  languageOptions,
  optiondeals,
  optionindustry,
  options,
  optionschoose,
  optionsource,
  optionssymbol,
  optionSalutation,
} from "../../../core/common/selectoption/selectoption";
import { useNavigate } from "react-router-dom";
import { label } from "yet-another-react-lightbox/*";
import { getAllContacts, getOpportunities } from "../deals/dealsAPI";
import { getAllCompanies } from "../companies/companyAPI";
import create from "@ant-design/icons/lib/components/IconFont";
import { getTagList } from "../tags/tagAPI";
import ActivityList from "../activity";
import { ACTIVITY_TYPES } from "../activity/activityAPI";
import Swal from 'sweetalert2';

const route = all_routes;
interface Tasks {
  id: number;
  uuid: string;
  title: string;
  category: string;
  responsible: { uuid: string; username: string };
  startDate: string;
  endDate: string;
  targetType: string;
  assignType: string;
  priority: string;
  status: string;
  description?: string
}

interface TagOption {
  value: number;
  label: string;
}
interface CreateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface UpdateTaskDTO {
  memberId: number;
  title: string;
  category: string;
  responsible: string;
  startDate: string;
  endDate?: string;
  status: string;
  priority: string;
  description?: string;
  assignType: string;
  assignId: number;
  targetType: string;
  targetId: number;
}
interface TaskDetailDTO {
  title: string;
  category: string;
  responsible: { uuid: string; username: string }
  startDate: string;
  endDate: string;
  assignTags: Array<{ id: number; uuid: string; name: string }>;
  priority: string;
  status: string;
  description: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string };
}

interface Lead {
  id: number;
  salutation: string;
  firstName: string;
  lastName: string;
  gender: string;
  dob: string;
  email?: string;
  phone?: string;
  mobile?: string;
  rating?: number;
  owner?: {
    id: number;
    uuid: string;
    name: string;
  }
  title?: string;
  leadSource?: string;
  leadStatusId?: number;
  leadStatus?: string;
  language?: string;
  description?: string;
  company?: string;
  industry?: string;
  website?: string;
  noOfEmployees?: number;
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  facebook?: string;
  skype?: string;
  linkedin?: string;
  twitter?: string;
  instagram?: string;
  whatsapp?: string;
  memberId: number;
  selectedPeople: number[];
  tags: Array<{
    tagId: number;
    name: string;
  }>;
  statusDto: {
    statusId: number;
    existedAccountId: number | null;
    existedContactId: number | null;
    existedOpportunityId: number | null;
    createContactRequestDTO: {
      salutation: string;
      firstName: string;
      lastName: string;
    };
    opportunityName: string;
    accountName: string;
    createOpportunity: boolean;
  };

  campaignHistory?: Array<{
    campaignId: string;
    campaignName: string;
    startDate: string;
    endDate: string;
    type: string;
    status: string;
  }>;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  public: boolean;
}

interface LogCall {
  id: number;
  uuid?: string;
  status: string;
  userCall?: string;
  callTime?: string;
  notes?: string;
  followUpTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}
interface Event {
  id: number;
  uuid: string;
  subject: string;
  description: string;
  startTime: string;
  endTime: string;
}

interface LogCallDataCreate {
  userCall?: string;
  status: string;
  followUpDate: string;
  note: string;
  assignType: string;
  assignRecord: number;
  targetType: string;
  targetRecord: number;
  checkedCreateFollowingTask: boolean;
}
interface LogCallDataUpdate {
  userCall?: string;
  status: string;
  followUpDate: string;
  note: string;
  assignType?: string;
  assignRecord?: number;
  targetType?: string;
  targetRecord?: number;
}
interface LogCallDataDetail {
  id: number;
  uuid?: string;
  status: string;
  userCall: { uuid: string; username: string };
  callTime: string;
  notes: string;
  followUpTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string };
}
interface LeadListDTO {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company: string;
  phone: string;
  email: string;
  leadStageId: number;
  leadStatus: string;
  createdDate: string;
  leadOwner: string;
}
interface ContactlListDTO {
  contactId: number;
  contactName: string;
}
interface OpportunityListDTO {
  id: number;
  name: string;
}
interface CampaignListDTO {
  campaignId: number;
  campaignName: string;
}
interface AccountListDTO {
  accountId: number;
  accountName: string;
}
interface UserCall {
  id: number;
  uuid: string;
  username: string;
  role: string;
}
interface Stage {
  id: number;
  name: string;
  order: number;
}
interface Account {
  accountId: number;
  accountName: string;
  type?: "new" | "existing";
}

interface Contact {
  contactId: number;
  contactName: string;
  salutation?: string;
  firstName?: string;
  lastName?: string;
  type?: "new" | "existing";
}

interface Opportunity {
  id: number;
  name: string;
  type?: "new" | "existing";
}

interface Owner {
  id: number;
  name: string;
}

interface ConvertLeadForm {
  account: Account | null;
  contact: Contact | null;
  opportunity: Opportunity | null;
  owner: Owner | null;
  leadStatus?: string;
}
interface LeadConvert {
  leadId: number;
  leadUuid: string;
  leadName: string;
  company?: string;
  phone: string;
  email: string;
  leadStageId?: number;
  leadStatus?: string;
  createdDate: string;
  leadOwner?: string;
}
interface CreateEventDTO {
  subject: string;
  description: string;
  attendees: number[];
  location: string;
  targetType: string;
  targetIds: number | null;
  assignType: string;
  assigneeId: number[];
  startTime: string;
  endTime: string;
}
interface UpdateEventDTO {
  subject: string;
  description: string;
  attendees: number[];
  location: string;
  targetType: string;
  targetIds: number | null;
  assignType: string;
  assigneeId: number[];
  startTime: string;
  endTime: string;
}
interface EventDetailDTO {
  subject: string;
  description: string;
  attendees: { id: number; name: string }[];
  location: string;
  targetType: string;
  targets: { id: number; name: string };
  assignType: string;
  assignee: { id: number; name: string }[];
  startTime: string;
  endTime: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}
const formatDateForInput = (dateString: string) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
const getValidUrl = (url?: string | null): string => {
  if (!url) return "#";
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `https://${url}`;
};
const LeadsDetails = () => {
  const [reloadActivity, setReloadActivity] = useState(false);
  const [selectedName, setSelectedName] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedUserCall, setSelectedUserCall] = useState("");
  const [selectedTaskResponsible, setSelectedTaskResponsible] = useState("");
  const [selectedLogCallId, setSelectedLogCallId] = useState<{ id: number } | null>(null);
  const [selectedTaskId, setSelectedTaskId] = useState<{ id: number } | null>(null);
  const [editingLogCall, setEditingLogCall] = useState<LogCallDataUpdate | null>(null);
  const [detailLogCallData, setDetailLogCallData] = useState<LogCallDataDetail | null>(null);
  const [editingTask, setEditingTask] = useState<TaskDetailDTO | null>(null);
  const [listLeadAssignType, setListLeadAssignType] = useState<LeadListDTO[]>([]);
  const [listContactAssignType, setListContactAssignType] = useState<ContactlListDTO[]>([]);
  const [listAccountRelatedToType, setListAccountRelatedToType] = useState<AccountListDTO[]>([]);
  const [listOpportunitiesRelatedToType, setListOpportunitiesRelatedToType] = useState<OpportunityListDTO[]>([]);
  const [showConvertModal, setShowConvertModal] = useState(false);
  const navigate = useNavigate();
  const { uuid } = useParams();
  const [stages, setStages] = useState<Stage[]>([]);
  const [lead, setLead] = useState<Lead | null>(null);
  const [logCallToCreate, setLogCallToCreate] = useState<LogCallDataCreate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [show3, setShow3] = useState(false);
  const [logCalls, setLogCalls] = useState<LogCall[]>([]);
  const [tasks, setTasks] = useState<Tasks[]>([]);
  const [createdLeadUuid, setCreatedLeadUuid] = useState(null);
  const [editedLeadUuid, setEditedLeadUuid] = useState(null);
  const [editingLead, setEditingLead] = useState<Lead | null>(null);
  const [leadToDelete, setLeadToDelete] = useState<{ id: number; name: string } | null>(null);
  const [logCallToDelete, setLogCallToDelete] = useState<{ id: number } | null>(null);
  const [taskToDelete, setTaskToDelete] = useState<{ id: number } | null>(null);
  const [showEditLogCallModal, setShowEditLogCallModal] = useState(false);
  const [showDeleteLogCallModal, setShowDeleteLogCallModal] = useState(false);
  const [logCallStatus, setLogCallStatus] = useState<string>("");
  const [logCallFollowUpDate, setLogCallFollowUpDate] = useState<string>("");
  const [logCallNote, setLogCallNote] = useState<string>("");
  const [logCallUserCall, setLogCallUserCall] = useState<string>("");
  const [listUserCall, setListUserCall] = useState<UserCall[]>([]);
  const [taskTitle, setTaskTitle] = useState<string>("");
  const [taskCategory, setTaskCategory] = useState<string>("");
  const [taskStartDate, setTaskStartDate] = useState<string>("");
  const [taskEndDate, setTaskEndDate] = useState<string>("");
  const [taskStatus, setTaskStatus] = useState<string>("");
  const [taskPiority, setTaskPriority] = useState<string>("");
  const [taskDescription, setTaskDescription] = useState<string>("");
  const [assignType, setAssignType] = useState("");
  const [relatedType, setSelectRelatedType] = useState("");
  const [assignTaskType, setAssignTaskType] = useState("");
  const [relatedTaskType, setSelectRelatedTaskType] = useState("");
  const [assignOptions, setAssignOptions] = useState<{ value: number; label: string }[]>([]);
  const [relateOptions, setRelateOptions] = useState<{ value: number; label: string }[]>([]);
  const [selectedAssignOption, setSelectedAssignOption] = useState<{ value: number; label: string } | null>(null);
  const [selectedRelateOption, setSelectedRelateOption] = useState<{ value: number; label: string } | null>(null);
  const [assignTaskOptions, setAssignTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [relateTaskOptions, setRelateTaskOptions] = useState<{ value: number; label: string }[]>([]);
  const [selectedTaskAssignOption, setSelectedTaskAssignOption] = useState<{ value: number; label: string } | null>(null);
  const [selectedTaskRelateOption, setSelectedTaskRelateOption] = useState<{ value: number; label: string } | null>(null);
  const [accountOptions, setAccountOptions] = useState<{ value: string; label: string }[]>([]);
  const [contactOptions, setContactOptions] = useState<{ value: string; label: string }[]>([]);
  const [opportunityOptions, setOpportunityOptions] = useState<{ value: string; label: string }[]>([]);
  const [ownerOptions, setOwnerOptions] = useState<{ value: string; label: string }[]>([]);
  const [accountType, setAccountType] = useState<"new" | "existing">("existing");
  const [contactType, setContactType] = useState<"new" | "existing">("existing");
  const [opportunityType, setOpportunityType] = useState<"new" | "existing">("existing");
  const [accountName, setAccountName] = useState("");
  const [contactFirstName, setContactFirstName] = useState("");
  const [contactLastName, setContactLastName] = useState("");
  const [opportunityName, setOpportunityName] = useState("");
  const [selectedAccount, setSelectedAccount] = useState<{ value: string; label: string } | null>(null);
  const [selectedContact, setSelectedContact] = useState<{ value: string; label: string } | null>(null);
  const [selectedOpportunity, setSelectedOpportunity] = useState<{ value: string; label: string } | null>(null);
  const [selectedOwners, setSelectedOwners] = useState<OptionType[]>([]);
  type OptionType = { value: string; label: string };
  const [selectedSalutation, setSelectedSalutation] = useState<string | null>(null);
  const [createLogCallFollowingTask, setLogCallCreateFollowingTask] = useState<boolean>(false);
  const [selectedLeadContactId, setSelectedLeadContactId] = useState<{ id: number } | null>(null);


  /*Events*/
  const [events, setEvents] = useState<Event[]>([]);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [response, setResponse] = useState<{ status: "success" | "error"; message: string } | null>(null);
  const [eventDetail, setEventDetail] = useState<EventDetailDTO | null>(null);
  const [attendees, setAttendees] = useState<{ value: number; label: string }[]>([]);
  const [newEventData, setNewEventData] = useState({
    subject: "",
    description: "",
    attendees: [] as number[],
    location: "",
    targetType: "",
    targetIds: null as number | null,
    assignType: "",
    assigneeId: [] as number[],
    startTime: "",
    endTime: ""
  });
  const [editEventData, setEditEventData] = useState({
    subject: "",
    description: "",
    attendees: [] as number[],
    location: "",
    targetType: "",
    targetIds: null as number | null,
    assignType: "",
    assigneeId: [] as number[],
    startTime: "",
    endTime: ""
  });
  const attendeesOptions = listUserCall.map((user) => ({
    value: user.id,
    label: user.username,
  }));
  const selectedAttendees = attendeesOptions.filter(option =>
    editEventData.attendees.includes(option.value)
  );
  const [selectedEventId, setSelectedEventId] = useState<number | null>(null);
  const handleSelectAttendeesChange = (selectedOptions: any) => {
    setAttendees(selectedOptions);
    setNewEventData((prevData) => ({
      ...prevData,
      attendees: selectedOptions ? selectedOptions.map((option: { value: number }) => option.value) : [],
    }));
    setEditEventData({
      ...editEventData,
      attendees: selectedOptions.map((option: { value: number }) => Number(option.value)),
    });
  };

  const getNewEventData = (): CreateEventDTO => {
    return {
      subject: newEventData.subject,
      description: newEventData.description,
      attendees: newEventData.attendees,
      location: newEventData.location,
      startTime: newEventData.startTime
        ? new Date(
          new Date(newEventData.startTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endTime: newEventData.endTime
        ? new Date(
          new Date(newEventData.endTime).getTime()
        ).toISOString()
        : new Date().toISOString(),
      assignType: newEventData.assignType,
      assigneeId: newEventData.assigneeId,
      targetType: newEventData.targetType,
      targetIds: newEventData.targetIds,
    };
  };
  const getEditEventData = (): UpdateEventDTO => {
    return {
      subject: editEventData.subject,
      description: editEventData.description,
      attendees: editEventData.attendees,
      location: editEventData.location,
      startTime: editEventData.startTime
        ? new Date(new Date(editEventData.startTime).getTime()).toISOString()
        : new Date().toISOString(),
      endTime: editEventData.endTime
        ? new Date(new Date(editEventData.endTime).getTime()).toISOString()
        : new Date().toISOString(),
      assignType: editEventData.assignType,
      assigneeId: editEventData.assigneeId,
      targetType: editEventData.targetType,
      targetIds: editEventData.targetIds,
    };
  };
  const handleCreateEvent = async () => {
    try {
      const newEvent = getNewEventData();
      const response = await createEvent(newEvent);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Event created successfully!" });
        fetchEvents();
        resetNewEventForm();
        setAttendees([]);
      }
    } catch (err) {
      console.error("Error creating event:", err);
      setResponse({ status: "error", message: "Event created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const resetNewEventForm = () => {
    setNewEventData({
      subject: "",
      description: "",
      attendees: [] as number[],
      location: "",
      targetType: "",
      targetIds: null as number | null,
      assignType: "",
      assigneeId: [] as number[],
      startTime: "",
      endTime: ""
    });
  };
  const resetEditEventForm = () => {
    setEditEventData({
      subject: "",
      description: "",
      attendees: [] as number[],
      location: "",
      targetType: "",
      targetIds: null as number | null,
      assignType: "",
      assigneeId: [] as number[],
      startTime: "",
      endTime: ""
    });
  };
  const fetchEvents = async () => {
    if (!lead?.id) return;
    setLoading(true);
    setError("");
    try {
      const response = await ViewMemberEvent("LEAD", lead?.id);
      setEvents(response.data.data || []);
    } catch (err) {
      setError("Failed to load events.");
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteEventClick = async (eventId: number) => {
    setSelectedEventId(eventId);
    setShowDeleteModal(true);
  }
  const handleDeleteEventConfirm = async () => {
    if (!selectedEventId) return;
    try {
      const response = await deleteEvent(selectedEventId);
      if (response.status === 200) {
        fetchEvents();
        setResponse({ status: "success", message: "Delete event successfully!" });
        setSelectedEventId(0);
      }
    } catch (error: any) {
      console.error("Failed to delete:", error);
      setResponse({ status: "error", message: error.response?.data?.message || "Failed to delete event." });
    } finally {
      setShowDeleteModal(false);
      setShowMessageModal(true);
    }
  };
  const fetchSelectedEvent = async (id: number) => {
    try {
      const response = await getEventDetail(id);
      const eventData = response.data.data as EventDetailDTO;
      setEventDetail({
        ...eventData,
        attendees: eventData.attendees || [],
        assignee: eventData.assignee || []
      });
      setEditEventData({
        subject: eventData.subject || "",
        description: eventData.description || "",
        attendees: eventData.attendees?.map(att => att.id) || "",
        location: eventData.location || "",
        assignType: eventData.assignType || "",
        assigneeId: eventData.assignee?.map(ass => ass.id) || 0,
        targetType: eventData.targetType || "",
        targetIds: eventData.targets ? eventData.targets.id : 0,
        startTime: formatDateForInput(eventData.startTime),
        endTime: formatDateForInput(eventData.endTime),
      });
      console.log("EventDetailabcxyz: ", editEventData)
    } catch (err) {
      console.error("Error fetching event details:", err);
    }
  };
  const handleEditClickEvent = (id: number) => {
    setSelectedEventId(id);
    fetchSelectedEvent(id);
  }
  const handleUpdateEvent = async () => {
    if (!selectedEventId) {
      return;
    }
    try {
      const editEvent = getEditEventData();
      const response = await updateEvent(selectedEventId, editEvent);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Event updated successfully!" });
        fetchEvents();
        resetEditEventForm();
        setAttendees([]);
      }
    } catch (err) {
      console.error("Error creating event:", err);
      setResponse({ status: "error", message: "Event updated failed!" });
    } finally {
      setShowMessageModal(true);
    }
  };
  /*Events*/
  const [selectedStatus, setSelectedStatus] = useState<number | "">("");

  useEffect(() => {
    if (editingLead) {
      console.log("Editing Lead:", editingLead);
      console.log("Status ID:", editingLead?.statusDto?.statusId, "Lead Stage ID:", editingLead?.leadStatusId);
      setSelectedStatus(editingLead?.statusDto?.statusId ?? editingLead?.leadStatusId ?? "");
    }
  }, [editingLead]);
  useEffect(() => {
    if (editingTask) {
      if (editingTask.assignType === "LEAD") {
        setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
      } else if (editingTask.assignType === "CONTACT") {
        setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
      }
      if (editingTask.targetType === "ACCOUNT") {
        setRelateTaskOptions(listAccountRelatedToType.map(t => ({ value: t.accountId, label: t.accountName })));
      } else if (editingTask.targetType === "OPPORTUNITY") {
        setRelateTaskOptions(listOpportunitiesRelatedToType.map(t => ({ value: t.id, label: t.name })));
      }
    }
  }, [editingTask, listLeadAssignType, listContactAssignType, listAccountRelatedToType, listOpportunitiesRelatedToType]);

  const [isEditingStatus, setIsEditingStatus] = useState(false);
  const [selectedNewStatus, setSelectedNewStatus] = useState<number | "">(lead?.leadStatusId || "");
  const [tagOptions, setTagOptions] = useState<{ label: string; value: number }[]>([]);
  const [allTags, setAllTags] = useState<{ id: number; name: string }[]>([]);
  const fetchTags = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await getTagList();
      const tags = response.data.data.map((tag: { id: number; name: string }) => ({
        label: tag.name,
        value: tag.id,
      }));
      setAllTags(response.data.data)
      setTagOptions(tags);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  const handleTagChange = (selectedOptions: MultiValue<TagOption>) => {
    setEditingLead(prev => {
      if (!prev) return prev;
      return {
        ...prev,
        tags: selectedOptions
          ? selectedOptions.map(option => ({
            tagId: option.value,
            name: option.label
          }))
          : [],
        id: prev.id ?? 0,
        memberId: prev.memberId ?? 0,
      };
    });
  };


  useEffect(() => {
    setSelectedStatus(lead?.leadStatusId || "");
  }, [lead]);

  const [currentStage, setCurrentStage] = useState<number | "">(lead?.leadStatusId || "");

  const handleEditStatusClick = () => {
    setCurrentStage(lead?.leadStatusId || "");
    setSelectedNewStatus(lead?.leadStatusId || "");
    setIsEditingStatus(true);
  };


  const handleCancelEdit = () => {
    setSelectedStatus(lead?.leadStatusId || "");
    setIsEditingStatus(false);
  };

  const handleCloseConvertModal = () => {
    setSelectedStatus(lead?.leadStatusId || "");
    setShowConvertModal(false);
  };

  const handleStageClick = async (stageId: number) => {
    if (selectedStatus === stageId) return;

    const selectedStage = stages.find(stage => stage.id === stageId);
    if (!selectedStage) return;

    if (selectedStage.order === maxorder && currentStage !== selectedStage.id) {
      setSelectedStatus(stageId);
      setShowConvertModal(true);
      setIsEditingStatus(false);
      return;
    }

    const result = await Swal.fire({
      title: 'Change status?',
      text: "Do you want to change the lead status?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    });

    if (!result.isConfirmed) return;
    if (!lead?.id) return;

    try {
      const response = await updateLeadStatus(lead.id, {
        statusId: stageId,
        existedAccountId: null,
        existedContactId: null,
        existedOpportunityId: null,
        createContactRequestDTO: {
          salutation: null,
          firstName: null,
          lastName: null,
        }
      });

      if (response?.status === 200) {
        console.log("Lead status updated successfully");

        setLead((prevLead) => {
          if (!prevLead) return null;

          return {
            ...prevLead,
            leadStatusId: stageId,
            leadStatus: statusOptions.find((s: Stage) => s.id === stageId)?.name || prevLead.leadStatus,
          };
        });
      } else {
        console.error("Failed to update status", response);
      }
    } catch (error) {
      console.error("Error updating lead status:", error);
    }

    setIsEditingStatus(false);
  };

  const handleSaveStatus = async () => {
    if (!lead?.id) return;
    const selectedStage = stages.find(stage => stage.id === selectedStatus);
    if (selectedStage && selectedStage.order === maxorder && currentStage != selectedStage.id) {
      setShowConvertModal(true);
      setIsEditingStatus(false);
      return;
    }

    try {
      const response = await updateLeadStatus(lead.id, {
        statusId: selectedStatus,
        existedAccountId: null,
        existedContactId: null,
        existedOpportunityId: null,
        createContactRequestDTO: {
          salutation: null,
          firstName: null,
          lastName: null,
        }
      });

      if (response?.status === 200) {
        console.log("Lead status updated successfully");
        setLead((prevLead) => {
          if (!prevLead) return null;

          return {
            ...prevLead,
            leadStatusId: selectedStatus ? Number(selectedStatus) : prevLead.leadStatusId,
            leadStatus: statusOptions.find((s: Stage) => s.id === selectedStatus)?.name || prevLead.leadStatus,
          };
        });

      } else {
        console.error("Failed to update status", response);
      }
    } catch (error) {
      console.error("Error updating lead status:", error);
    }

    setIsEditingStatus(false);
  };

  const handleConvertLead = async () => {
    if (!lead?.id) {
      console.error("Error: No valid Lead ID found!", lead?.id);
      return;
    }

    try {
      const finalAccountName = accountType === "new" ? accountName || null : null;
      const finalOpportunityName = opportunityType === "new" ? opportunityName || null : null;

      const finalContactData =
        contactType === "new"
          ? {
            salutation: selectedSalutation || "",
            firstName: contactFirstName || "",
            lastName: contactLastName || "",
          }
          :
          {
            salutation: null,
            firstName: null,
            lastName: null,
          }
      const data = {
        statusId: selectedStatus,
        existedAccountId: accountType === "existing" ? Number(selectedAccount?.value) || null : null,
        existedContactId: contactType === "existing" ? Number(selectedContact?.value) || null : null,
        existedOpportunityId: opportunityType === "existing" ? Number(selectedOpportunity?.value) || null : null,
        createContactRequestDTO: finalContactData,
        opportunityName: finalOpportunityName,
        accountName: finalAccountName,
        createOpportunity: opportunityType === "new",
      };

      console.log("Dữ liệu gửi lên API:", data);

      const response = await updateLeadStatus(lead?.id, data);

      if (response?.status === 200) {
        setResponse({ status: "success", message: "Lead converted successfully!" });
        handleCloseConvertModal();
        fetchLead();
      } else {
        console.error("API Error:", response);
        setResponse({ status: "error", message: "Failed to convert lead. Please try again!" });

      }
    } catch (error) {
      console.error("Error converting lead:", error);
      setResponse({ status: "error", message: "An unexpected error occurred. Please check the console for details." });
    } finally {
      setShowMessageModal(true);
    }
  };


  const [maxorder, setMaxorder] = useState<number | null>(null);

  useEffect(() => {
    const fetchStatusEditOptions = async () => {
      try {
        const response = await getTypePipeline("LEAD");
        const data = response.data.data || [];
        console.log("Pipeline data:", data);
        setStatusOptions(data);

        const validorders = data.map((item: Stage) => item.order).filter((id: number) => id !== undefined && id !== null);
        const maxOrder = validorders.length > 0 ? Math.max(...validorders) : 0;

        console.log("Max order:", maxOrder);
        setMaxorder(maxOrder);

      } catch (error) {
        console.error("Error fetching status options:", error);
      }
    };

    fetchStatusEditOptions();
  }, []);

  const [errorsEditForm, setErrorsEditForm] = useState<Record<string, string>>({});

  const validateEditForm = () => {
    let newErrors: Record<string, string> = {};

    const isTooLong = (value: string, field: string, max: number = 50) => {
      if (value.trim().length > max) {
        newErrors[field] = `${field[0].toUpperCase() + field.slice(1)} must not exceed ${max} characters.`;
      }
    };

    const onlyDigits = (value: string) => /^\d+$/.test(value);

    const isValidPhone = (value: string) => {
      return /^0\d{9,10}$/.test(value);
    };

    if (editingLead) {
      if (!editingLead.firstName?.trim()) newErrors.firstName = "First Name is required";
      else isTooLong(editingLead.firstName, "firstName");

      if (!editingLead.lastName?.trim()) newErrors.lastName = "Last Name is required";
      else isTooLong(editingLead.lastName, "lastName");

      if (!editingLead.email?.trim()) newErrors.email = "Email is required";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editingLead.email)) newErrors.email = "Invalid email format";
      else isTooLong(editingLead.email, "email");

      if (!editingLead.phone?.trim()) newErrors.phone = "Phone is required";
      else if (!isValidPhone(editingLead.phone)) newErrors.phone = "Phone must start with 0 and contain 10–11 digits only.";

      if (editingLead.mobile && !isValidPhone(editingLead.mobile)) {
        newErrors.mobile = "Mobile must start with 0 and contain 10–11 digits only.";
      }

      if (!editingLead.company?.trim()) newErrors.company = "Company Name is required";
      else isTooLong(editingLead.company, "company");

      if (!editingLead.statusDto.statusId) newErrors.status = "Lead Status is required";

      if (!editingLead.owner) newErrors.owner = "Owner is required";

      if (!editingLead.dob?.trim()) newErrors.dob = "Date of Birth is required";

      if (!editingLead.gender?.trim()) newErrors.gender = "Gender is required";

      const fieldsMax50 = [
        "firstName", "lastName", "company", "email", "website",
        "title", "facebook", "skype", "linkedin", "twitter",
        "whatsapp", "instagram", "street", "city", "state", "country"
      ];
      fieldsMax50.forEach((field) => {
        const value = (editingLead as any)[field];
        if (value) isTooLong(value, field);
      });

      if (editingLead.description && editingLead.description.length > 256) {
        newErrors.description = "Description must not exceed 256 characters.";
      }

      if (editingLead.zip) {
        if (!onlyDigits(editingLead.zip) || editingLead.zip.length !== 6) {
          newErrors.zip = "ZIP must be 6 digits and contain digits only.";
        }
      }

      if (editingLead.noOfEmployees && (!/^\d+$/.test(editingLead.noOfEmployees.toString()) || Number(editingLead.noOfEmployees) >= 1000000)) {
        newErrors.noE = "Number of Employees must be a number less than 1,000,000.";
      }
    }

    setErrorsEditForm(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleUpdateLead = async () => {
    if (!editingLead?.id) {
      console.error("Error: No valid ID found for update!", editingLead);
      return;
    }

    if (!validateEditForm()) {
      console.error("Validation failed:", errorsEditForm);
      return;
    }
    const previousStatusId = editingLead.leadStatusId;
    const newStatusId = editingLead.statusDto.statusId;
    const previousStatus = statusOptions.find((status) => status.id === previousStatusId);
    const selectedStatus = statusOptions.find((status) => status.id === newStatusId);

    console.log("Previous Status:", previousStatus);
    console.log("Selected Status:", selectedStatus);
    console.log("Max order from state:", maxorder);

    const isStatusChanged = previousStatusId !== newStatusId;

    if (isStatusChanged && selectedStatus?.order === maxorder && previousStatus?.order !== maxorder) {
      console.log("Opening Convert Modal...");
      setShowConvertModal(true);
    } else {
      console.log("Updating lead...");
      if (previousStatusId === newStatusId) {
        const leadStatusId = editingLead?.leadStatusId;

        if (leadStatusId !== undefined) {
          editingLead.statusDto.statusId = leadStatusId;
        } else {
          console.error("leadStatusId is undefined!");
        }
      }
      await updateLeadData();
    }
  };


  const updateLeadData = async () => {
    try {
      if (!editingLead) {
        console.error("No data to update");
        return;
      }
      const leadToEdit = {
        ...newLead,
        dob: newLead.dob
          ? new Date(newLead.dob + "T00:00:00").toISOString()
          : null,
      };
      console.log("Updating Lead with ID:", editingLead.id);
      const response = await updateLead(editingLead.id, leadToEdit);
      if (response.status === 200) {
        console.log("Lead updated successfully");
        setOpenEditSuccessModal(true);
      }
    } catch (error) {
      console.error("Error updating lead:", error);
    }
  };
  const fetchContacts = async (accountId: number | null) => {
    if (!accountId) {
      setContactOptions([]);
      return;
    }

    try {
      const response = await getAllContactsConvert(accountId);
      const contacts = response.data.data.map((contact: Contact) => ({
        value: contact.contactId,
        label: contact.contactName,
      }));
      setContactOptions(contacts);
    } catch (error) {
      console.error("Error fetching Contacts:", error);
    }
  };
  const fetchOpportunities = async (accountId: number | null) => {
    if (!accountId) {
      setOpportunityOptions([]);
      return;
    }
    try {
      const response = await getOpportunitiesConvert(accountId);
      console.log("res:", response.data.data)
      const opportunities = response.data.data.map((oppor: Opportunity) => ({
        value: oppor.id,
        label: oppor.name,
      }));
      setOpportunityOptions(opportunities);
    } catch (error) {
      console.error("Error fetching Opportunities:", error);
    }
  };

  const fetchAccounts = async () => {
    try {
      const response = await getAllCompanies();
      const acc = response.data.data.map((acc: Account) => ({
        value: acc.accountId,
        label: acc.accountName,
      }));
      setAccountOptions(acc);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };

  const fetchOwners = async () => {
    try {
      const response = await listLeadsOption();
      const owners = response.data.data.map((lead: LeadConvert) => ({
        value: lead.leadUuid,
        label: lead.leadName,
      }));
      setOwnerOptions(owners);
    } catch (error) {
      console.error("Error fetching owners:", error);
    }
  };

  useEffect(() => {
    fetchAccounts();
    fetchOwners();
  }, []);

  useEffect(() => {
    if (selectedAccount?.value && selectedAccount.value !== "new") {
      const accountId = Number(selectedAccount.value);
      fetchContacts(accountId);
      fetchOpportunities(accountId);
      setSelectedContact(null);
      setSelectedOpportunity(null);
    } else {
      setContactOptions([]);
      setOpportunityOptions([]);
      setSelectedContact(null);
      setSelectedOpportunity(null);
    }
  }, [selectedAccount]);

  const [statusOptions, setStatusOptions] = useState<Stage[]>([]);
  const fetchStatusOptions = async () => {
    try {
      const response = await getTypePipeline("LEAD");
      if (response?.data) {
        console.log("Status option:", response.data.data);
        setStatusOptions(response.data.data.map((stage: Stage) => ({
          value: stage.id,
          label: stage.name
        })));
      }
    } catch (error) {
      console.error("Error fetching status options:", error);
    }
  };
  const [newTaskData, setNewTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });

  const [editTaskData, setEditTaskData] = useState({
    title: "",
    category: "",
    responsible: "",
    startDate: "",
    endDate: "",
    status: "",
    priority: "",
    description: "",
    assignType: "",
    assignId: 0,
    targetType: "",
    targetId: 0,
  });
  const updateNewTaskField = (field: string, value: any) => {
    setNewTaskData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updateEditTaskField = (field: string, value: any) => {
    setEditTaskData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const getNewTaskData = (): CreateTaskDTO => {
    return {
      memberId: lead?.id ?? 0,
      title: newTaskData.title,
      category: newTaskData.category,
      responsible: newTaskData.responsible,
      startDate: newTaskData.startDate
        ? new Date(
          new Date(newTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: newTaskData.endDate
        ? new Date(
          new Date(newTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: newTaskData.status,
      priority: newTaskData.priority,
      description: newTaskData.description,
      assignType: newTaskData.assignType,
      assignId: newTaskData.assignId,
      targetType: newTaskData.targetType,
      targetId: newTaskData.targetId,
    };
  };
  const getEditTaskData = (): UpdateTaskDTO => {
    return {
      memberId: lead?.id ?? 0,
      title: editTaskData.title,
      category: editTaskData.category,
      responsible: editTaskData.responsible,

      startDate: editTaskData.startDate
        ? new Date(
          new Date(editTaskData.startDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      endDate: editTaskData.endDate
        ? new Date(
          new Date(editTaskData.endDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      status: editTaskData.status,
      priority: editTaskData.priority,
      description: editTaskData.description,
      assignType: editTaskData.assignType,
      assignId: editTaskData.assignId,
      targetType: editTaskData.targetType,
      targetId: editTaskData.targetId,
    };
  };

  const handleCreateTasks = async () => {
    try {
      const newTask = getNewTaskData();
      const response = await createTask(newTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task created successfully!" });
        resetNewTaskForm();
        fetchTasks();
      }
    } catch (err) {
      console.error("Error creating task:", err);
      setResponse({ status: "error", message: "Task created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const handleUpdateTask = async (taskId: number) => {
    try {
      const updatedTask = getEditTaskData();
      const response = await updateTask(taskId, updatedTask);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Task updated successfully!" });
        fetchTasks();
        resetEditTaskForm();
      }
    } catch (err) {
      console.error("Error updating task:", err);
      setResponse({ status: "error", message: "Task updated failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };

  const resetNewTaskForm = () => {
    setNewTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };

  const resetEditTaskForm = () => {
    setEditTaskData({
      title: "",
      category: "",
      responsible: "",
      startDate: "",
      endDate: "",
      status: "",
      priority: "",
      description: "",
      assignType: "",
      assignId: 0,
      targetType: "",
      targetId: 0,
    });
  };
  const [newLogCall, setNewLogCall] = useState<LogCallDataCreate>({
    userCall: "",
    status: "",
    followUpDate: "",
    note: "",
    assignType: "LEAD",
    assignRecord: lead?.id ?? 0,
    targetType: "",
    targetRecord: 0,
    checkedCreateFollowingTask: false,
  });
  const resetAddLogCallForm = () => {
    setNewLogCall({
      userCall: "",
      status: "",
      followUpDate: "",
      note: "",
      assignType: "",
      assignRecord: 0,
      targetType: "",
      targetRecord: 0,
      checkedCreateFollowingTask: false,
    });
  };
  const getNewLogCallData = (): LogCallDataCreate => {
    return {
      userCall: newLogCall.userCall,
      status: newLogCall.status,
      followUpDate: newLogCall.followUpDate
        ? new Date(
          new Date(newLogCall.followUpDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      note: newLogCall.note,
      assignType: newLogCall.assignType,
      assignRecord: newLogCall.assignRecord,
      targetType: newLogCall.targetType,
      targetRecord: newLogCall.targetRecord,
      checkedCreateFollowingTask: newLogCall.checkedCreateFollowingTask,
    };
  };

  const [logCallDetail, setLogCallDetail] = useState<any>(null);
  const [editLogCall, setEditLogCall] = useState<LogCallDataUpdate>({
    userCall: "",
    status: "",
    followUpDate: "",
    note: "",
    assignType: "",
    assignRecord: 0,
    targetType: "",
    targetRecord: 0,
  });

  const handleCreateLogCall = async () => {
    try {
      const logCallData = getNewLogCallData();
      const response = await createLogCall(logCallData);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call created successfully!" });
        fetchLogCalls();
        resetAddLogCallForm();
      }
    } catch (err) {
      console.error("Error creating log call:", err);
      setResponse({ status: "error", message: "Log call created failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleUpdateLogCall = async (logCallId: number) => {
    if (!editLogCall) return;
    const updatedLogCall: LogCallDataUpdate = {
      userCall: editLogCall.userCall || "",
      status: editLogCall.status ?? "",
      followUpDate: editLogCall.followUpDate
        ? new Date(
          new Date(editLogCall.followUpDate).getTime()
        ).toISOString()
        : new Date().toISOString(),
      note: editLogCall.note ?? "",
      assignType: editLogCall.assignType,
      assignRecord: editLogCall.assignRecord,
      targetType: editLogCall.targetType,
      targetRecord: editLogCall.targetRecord,
    };

    try {
      const response = await updateLogCall(logCallId, updatedLogCall);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call updated successfully!" });
        fetchLogCalls();
      }
    } catch (err) {
      console.error("Error updating log call:", err);
      setResponse({ status: "error", message: "Log call updated failed!" });
    }
    finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  useEffect(() => {
    if (newTaskData.assignType === "LEAD") {
      setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
    } else if (newTaskData.assignType === "CONTACT") {
      setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
    }
    if (newEventData.assignType === "LEAD") {
      setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
    } else if (newLogCall.assignType === "CONTACT") {
      setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
    }
    if (newLogCall.assignType === "LEAD") {
      setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
    } else if (newLogCall.assignType === "CONTACT") {
      setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
    }
  }, [newTaskData.assignType, newLogCall.assignType, newEventData.assignType, listLeadAssignType, listContactAssignType]);
  useEffect(() => {
    if (assignTaskOptions.length > 0) {
      setNewTaskData(prev => ({
        ...prev,
        assignId: lead?.id ?? assignTaskOptions[0].value
      }));
    }
  }, [assignTaskOptions, lead]);
  useEffect(() => {
    const userUuid = localStorage.getItem("userUuid");
    if (lead) {
      setNewTaskData(prev => ({
        ...prev,
        assignType: "LEAD",
        assignId: lead.id ?? 0,
        responsible: userUuid || ""
      }));
      setNewEventData(prev => ({
        ...prev,
        assignType: "LEAD"
      }));
      setNewLogCall(prev => ({
        ...prev,
        assignType: "LEAD",
        assignRecord: lead.id ?? 0,
        userCall: userUuid || ""
      }));
    }
  }, [lead]);

  const handleConfirmDeleteLogCall = async () => {
    if (!logCallToDelete) return;
    console.log(logCallToDelete)
    try {
      const response = await deleteLogCall(logCallToDelete.id);
      if (response.status === 200) {
        console.log("Log call deleted successfully");
        setLogCalls((prevLogCalls) =>
          prevLogCalls.filter((logCall) => logCall.id !== logCallToDelete.id)
        );
        setResponse({ status: "success", message: "Log call deleted successfully!" });
      }
      setShowDeleteLogCallModal(false);
    } catch (err) {
      setResponse({ status: "error", message: "Log call deleted failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleConfirmDeleteTask = async () => {
    if (!taskToDelete) return;
    console.log(taskToDelete)
    try {
      const response = await deleteTask(taskToDelete.id);
      if (response.status === 200) {
        console.log("Log call deleted successfully");
        setResponse({ status: "success", message: "Task deleted successfully!" });
        setTasks((prevTask) =>
          prevTask.filter((taskToDelete) => taskToDelete.id !== taskToDelete.id)
        );
        fetchTasks();
      }
    } catch (err) {
      console.error("Error deleting task", err);
      setResponse({ status: "error", message: "Task deleted failed!" });
    }
    finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleUpdateLogCallStatus = async (id: number, status: string) => {
    console.log(status, "abc");
    try {
      const response = await updateLogCallStatus(id, status);
      if (response.status === 200) {
        setResponse({ status: "success", message: "Log call status updated successfully!" });
        fetchLogCalls();
      }
    } catch (error) {
      setResponse({ status: "success", message: "Log call status updated failed!" });
    } finally {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "auto";
      setShowMessageModal(true);
    }
  };
  const handleEditClickLogCall = (id: number) => {
    console.log(id, "asdad");
    setSelectedLogCallId({ id });
    fetchSelectedLogCall(id);
  }
  const handleEditClickTask = (id: number) => {
    console.log(id, "asdad");
    setSelectedTaskId({ id });
    fetchSelectedTask(id);
  }

  const handleDeleteClickLogCall = (id: number) => {
    setLogCallToDelete({ id });
    setShowDeleteLogCallModal(true);
  };
  const handleDeleteClickTask = (id: number) => {
    setTaskToDelete({ id });
  };
  const handleClose3 = () => {
    setShow3(false);
  }
  const fetchLogCalls = async () => {
    if (!lead?.id) return;
    setLoading(true);
    setError("");
    try {
      const response = await viewMemberLogCall("LEAD", lead?.id);
      console.log("LeadID: " + lead?.id);
      setLogCalls(response.data.data || []);
    } catch (err) {
      console.error("Error fetching log calls:", err);
      setError("Failed to load log calls.");
    } finally {
      setLoading(false);
    }
  };

  const fetchTasks = async () => {
    if (!lead?.id) return;
    setLoading(true);
    setError("");
    try {
      const response = await viewMemberTasks("LEAD", lead?.id);
      console.log("LeadID: " + lead?.id);
      setTasks(response.data.data || []);
    } catch (err) {
      console.error("Error fetching tasks", err);
      setError("Failed to load tasks.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (lead?.id) {
      fetchLogCalls();
      fetchEvents();
      fetchTasks();
    }
  }, [lead?.id]);
  //This method 
  const fetchListLeadAssignType = async () => {
    try {
      const response = await listLeadsOption();
      setListLeadAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching leads: ", err);
      setError("Failed to load leads.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListLeadAssignType();
  }, []);
  const fetchListContactAssignType = async () => {
    try {
      const response = await listContactsOptionn();
      setListContactAssignType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching contacts: ", err);
      setError("Failed to load contacts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListContactAssignType();
  }, []);
  const fetchAccountRelatedToType = async () => {
    try {
      const response = await listAccountsOption();
      setListAccountRelatedToType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching accounts: ", err);
      setError("Failed to load accounts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAccountRelatedToType();
  }, []);
  const fetchListOpportunitiesRelatedToType = async () => {
    try {
      const response = await listOpportunitiesOption();
      setListOpportunitiesRelatedToType(response.data.data || []);
    } catch (err) {
      console.error("Error fetching opportunities: ", err);
      setError("Failed to load opportunities.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchListOpportunitiesRelatedToType();
  }, []);
  const handleAssignTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;
    setAssignType(selectedType);
    setSelectedAssignOption(null);
    if (selectedType === "LEAD") {
      setAssignOptions(
        listLeadAssignType.map((t) => ({ value: t.leadId, label: t.leadName }))
      );
    } else if (selectedType === "CONTACT") {
      setAssignOptions(
        listContactAssignType.map((t) => ({ value: t.contactId, label: t.contactName }))
      );
    } else {
      setAssignOptions([]);
    }
  };
  const handleTaskAssignTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;

    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "LEAD") {
      newOptions = listLeadAssignType.map((t) => ({ value: t.leadId, label: t.leadName }));
    } else if (selectedType === "CONTACT") {
      newOptions = listContactAssignType.map((t) => ({ value: t.contactId, label: t.contactName }));
    }
    setAssignTaskOptions(newOptions);
    setNewLogCall((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignRecord: newOptions[0].value })
    }));
    setEditLogCall((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignRecord: newOptions[0].value })
    }));
    setNewTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setNewEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));
    setEditEventData((prev) => ({
      ...prev,
      assignType: selectedType,
      ...(newOptions.length > 0 && { assignId: newOptions[0].value })
    }));

  };
  const handleTaskRelatedToTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedType = e.target.value;

    let newOptions: { value: number; label: string }[] = [];
    if (selectedType === "ACCOUNT") {
      newOptions = listAccountRelatedToType.map((t) => ({ value: t.accountId, label: t.accountName }));
    } else if (selectedType === "OPPORTUNITY") {
      newOptions = listOpportunitiesRelatedToType.map((t) => ({ value: t.id, label: t.name }));
    }
    setRelateTaskOptions(newOptions);
    setNewLogCall((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetRecord: newOptions[0].value })
    }));
    setEditLogCall((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetRecord: newOptions[0].value })
    }));
    setNewTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setEditTaskData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setNewEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
    setEditEventData((prev) => ({
      ...prev,
      targetType: selectedType,
      ...(newOptions.length > 0 && { targetId: newOptions[0].value })
    }));
  };
  const fetchSelectedLogCall = async (id: number) => {
    try {
      setSelectedLogCallId({ id });
      const response = await detailLogCall(id);
      const logCallData = response.data.data;
      setLogCallDetail(logCallData);
      setEditLogCall({
        userCall: logCallData.userCall?.uuid || "",
        status: logCallData.status || "",
        followUpDate: formatDateForInput(logCallData.followUpTime),
        note: logCallData.notes || "",
        assignType: logCallData.assignType || "",
        assignRecord: logCallData.assignee?.id || 0,
        targetType: logCallData.targetType || "",
        targetRecord: logCallData.targets?.id || 0,
      });
      if (logCallData.assignType === "LEAD") {
        setAssignTaskOptions(listLeadAssignType.map(t => ({ value: t.leadId, label: t.leadName })));
      } else if (logCallData.assignType === "CONTACT") {
        setAssignTaskOptions(listContactAssignType.map(t => ({ value: t.contactId, label: t.contactName })));
      }

      if (logCallData.targetType === "ACCOUNT") {
        setRelateTaskOptions(listAccountRelatedToType.map(t => ({ value: t.accountId, label: t.accountName })));
      } else if (logCallData.targetType === "OPPORTUNITY") {
        setRelateTaskOptions(listOpportunitiesRelatedToType.map(t => ({ value: t.id, label: t.name })));
      }
      setShowEditLogCallModal(true);
    } catch (err) {
      console.error("Error fetching log calls:", err);
      setError("Failed to load log calls.");
    } finally {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   setEditLogCall(prev => ({
  //     ...prev,
  //     assignRecord: assignTaskOptions.find(opt => opt.value === prev.assignRecord)?.value || 0
  //   }));
  //   setEditTaskData(prev => ({
  //     ...prev,
  //     assignRecord: assignTaskOptions.find(opt => opt.value === prev.assignId)?.value || 0
  //   }));
  //   setEditEventData(prev => ({
  //     ...prev,
  //     assignRecord: assignTaskOptions.find(opt => prev.assigneeId.includes(opt.value))?.value || 0
  //   }));
  // }, [assignTaskOptions]);

  // useEffect(() => {
  //   setEditLogCall(prev => ({
  //     ...prev,
  //     targetRecord: relateTaskOptions.find(opt => opt.value === prev.targetRecord)?.value || 0
  //   }));
  //   setEditTaskData(prev => ({
  //     ...prev,
  //     targetRecord: relateTaskOptions.find(opt => opt.value === prev.targetId)?.value || 0
  //   }));
  //   setEditEventData(prev => ({
  //     ...prev,
  //     targetRecord: relateTaskOptions.find(opt => opt.value === prev.targetIds)?.value || 0
  //   }));
  // }, [relateTaskOptions]);

  const fetchSelectedTask = async (id: number) => {
    try {
      setSelectedTaskId({ id: id });
      const response = await detailTask(id);
      console.log(response.data.data, "hihihhehehe");
      setEditingTask(response.data.data);
      setEditTaskData({
        title: response.data.data.title || "",
        category: response.data.data.category || "",
        responsible: response.data.data.responsible.uuid || "",
        startDate: formatDateForInput(response.data.data.startDate),
        endDate: formatDateForInput(response.data.data.endDate),
        status: response.data.data.status || "",
        priority: response.data.data.priority || "",
        description: response.data.data.description || "",
        assignType: response.data.data.assignType || "",
        assignId: response.data.data.assignee.id ?? 0,
        targetType: response.data.data.targetType || "",
        targetId: response.data.data.assignee.id ?? 0,
      });
    } catch (err) {
      console.error("Error fetching task.", err);
      setError("Failed to load task.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setSelectedUserCall(editingLogCall?.userCall || "");
  }, [editingLogCall]
  );



  const fetchUserCallList = async () => {
    try {
      const userTenantId = Number(localStorage.getItem("userTenantId"));
      console.log("UserTenantIDabcabc: ", userTenantId)
      const response = await userList(userTenantId);
      setListUserCall(response.data.data || []);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError("Failed to load users.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserCallList();
  }, []);


  useEffect(() => {
    const fetchStages = async () => {
      try {
        const response = await getTypePipeline("LEAD");
        setStages(response.data.data || []);
      } catch (error) {
        console.error("Error fetching pipeline stages:", error);
      }
    };

    fetchStages();
  }, []);
  const COLORS = ["success", "danger", "warning", "info", "pending", "pink"];
  const getStageColor = (index: number) => COLORS[index % COLORS.length];


  const handleDeleteClick = (id: number, name: string) => {
    setLeadToDelete({ id, name });
  };
  const handleEditClick = async (leadUuid: string) => {
    console.log("Lead UUID:", leadUuid);
    try {
      const response = await getLeadDetail(leadUuid);
      console.log("API response:", response.data.data);

      if (response.status === 200) {
        const leadData = response.data.data;
        setEditingLead({
          ...leadData,
          statusDto: {
            statusId: leadData.leadStatusId ?? 0,
            existedAccountId: null,
            existedContactId: null,
            existedOpportunityId: null,
            createContactRequestDTO: {
              salutation: leadData.salutation || "",
              firstName: leadData.firstName || "",
              lastName: leadData.lastName || "",
            },
            opportunityName: "",
            accountName: "",
            createOpportunity: false,
          },
        });
        setEditedLeadUuid(leadData.uuid);
        setShow3(true);
      }
    } catch (error) {
      console.error("Error fetching lead details:", error);
    }
  };

  const [openEditSuccessModal, setOpenEditSuccessModal] = useState(false);

  const handleConfirmDelete = async () => {
    if (!leadToDelete) return;

    try {
      await deleteLead(leadToDelete.id);
      setLead(null);
      setLeadToDelete(null);
      navigate("/leads");
    } catch (error) {
      console.error("Error deleting lead:", error);
    }
  };

  const [newLead, setNewLead] = useState({
    id: 0,
    salutation: "",
    firstName: "",
    lastName: "",
    email: "",
    gender: "",
    dob: "",
    phone: "",
    mobile: "",
    rating: 0,
    owner: "",
    title: "",
    leadSource: "",
    leadStatus: "",
    leadStatusId: 0,
    language: "",
    description: "",
    company: "",
    industry: "",
    website: "",
    noOfEmployees: 0,
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    facebook: "",
    skype: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    whatsapp: "",
    memberId: 0,
    selectedPeople: [] as number[],
    tags: [] as { tagId?: number; name: string }[],
    statusDto: {
      statusId: 0,
      existedAccountId: null as number | null,
      existedContactId: null as number | null,
      existedOpportunityId: null as number | null,
      createContactRequestDTO: {
        salutation: "",
        firstName: "",
        lastName: "",
      },
      opportunityName: "",
      accountName: "",
      createOpportunity: false,
    },
    public: true,
  });

  useEffect(() => {
    if (editingLead) {
      setNewLead({
        id: typeof editingLead.id === "number" ? editingLead.id : 0,
        leadStatus: editingLead.leadStatus || "",
        leadStatusId: editingLead.leadStatusId || 0,
        salutation: editingLead.salutation || "",
        firstName: editingLead.firstName || "",
        lastName: editingLead.lastName || "",
        email: editingLead.email || "",
        phone: editingLead.phone || "",
        gender: editingLead.gender || "",
        dob: editingLead.dob || "",
        mobile: editingLead.mobile || "",
        rating: editingLead.rating ?? 0,
        owner: editingLead.owner?.uuid || "",
        title: editingLead.title || "",
        leadSource: editingLead.leadSource || "",
        language: editingLead.language || "",
        description: editingLead.description || "",
        company: editingLead.company || "",
        industry: editingLead.industry || "",
        website: editingLead.website || "",
        noOfEmployees: editingLead.noOfEmployees ?? 0,
        street: editingLead.street || "",
        city: editingLead.city || "",
        state: editingLead.state || "",
        zip: editingLead.zip || "",
        country: editingLead.country || "",
        facebook: editingLead.facebook || "",
        skype: editingLead.skype || "",
        linkedin: editingLead.linkedin || "",
        twitter: editingLead.twitter || "",
        instagram: editingLead.instagram || "",
        whatsapp: editingLead.whatsapp || "",
        memberId: editingLead.memberId ?? 0,
        selectedPeople: editingLead.selectedPeople || 0,
        tags: editingLead.tags
          ? editingLead.tags.map(tag => ({
            tagId: tag.tagId ?? 0,
            name: tag.name,
          }))
          : [],
        statusDto: {
          statusId: editingLead.statusDto?.statusId ?? 0,
          existedAccountId: editingLead.statusDto?.existedAccountId ?? null,
          existedContactId: editingLead.statusDto?.existedContactId ?? null,
          existedOpportunityId: editingLead.statusDto?.existedOpportunityId ?? null,
          createContactRequestDTO: {
            salutation: editingLead.statusDto?.createContactRequestDTO?.salutation || "",
            firstName: editingLead.statusDto?.createContactRequestDTO?.firstName || "",
            lastName: editingLead.statusDto?.createContactRequestDTO?.lastName || "",
          },
          opportunityName: editingLead.statusDto?.opportunityName || "",
          accountName: editingLead.statusDto?.accountName || "",
          createOpportunity: editingLead.statusDto?.createOpportunity ?? false,
        },
        public: editingLead.public ?? true,
      });
    }
  }, [editingLead]);


  const selectedLead = listLeadAssignType.find((t) => t.leadId === lead?.id);

  const handleSelectChange = (e: any, field: string) => {
    setEditLogCall((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: field === "userCall" ? e.target.value : e?.target?.value || e.value,
      };
    });
    setEditingTask((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: e?.target ? e.target.value : e.value
      };
    });
    setEditEventData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: e?.target ? e.target.value : e.value
      };
    });
  };

  const handleSelectChangeEdit = (
    selectedOption: { value: string; label: string } | null,
    field: string
  ) => {
    setNewLead((prevState) => {
      if (!prevState) return prevState;

      return {
        ...prevState,
        [field]: selectedOption ? selectedOption.value : ""
      };
    });
    setEditingLead((prevState) => {
      if (!prevState) return prevState;

      return {
        ...prevState,
        [field]: selectedOption ? selectedOption.value : ""
      };
    });
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setEditLogCall((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setNewTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditTaskData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleUpdateTaskInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setEditLogCall((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditEventData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEditTaskData((prevData) => {
      if (!prevData) return prevData;
      return {
        ...prevData,
        [name]: name === "memberId" || name === "assignId" || name === "targetId" ? Number(value) || 0 : value,
      };
    });
  };

  const handleUpdateTaskSelectChange = (name: string, value: string | number) => {
    setEditLogCall((prevData) => {
      if (!prevData) return prevData;

      if (name === "assignRecord") {
        return {
          ...prevData,
          assignRecord: value as number,
        };
      }

      if (name === "targetRecord") {
        return {
          ...prevData,
          targetRecord: value as number,
        };
      }

      return {
        ...prevData,
        [name]: value,
      };
    });
    setEditingTask((prevData) => {
      if (!prevData) return prevData;
      if (name === "assignId") {
        return {
          ...prevData,
          assignee: {
            ...prevData.assignee,
            id: value as number,
          },
        };
      }

      if (name === "targetId") {
        return {
          ...prevData,
          targets: {
            ...prevData.targets,
            id: value as number,
          },
        };
      }
      return {
        ...prevData,
        [name]: value,
      };
    });

  };
  const fetchLead = async () => {
    if (!uuid) return;
    try {
      const response = await getLeadDetail(uuid);
      if (response.data && response.data.data) {
        setLead(response.data.data);
      } else {
        setLead(null);
      }
    } catch (error: any) {
      if (error.response?.data?.code === 1040) {
        navigate("/error-404");
      }
    }
  };
  useEffect(() => {
    fetchLead();
  }, [uuid]);
  const [stars, setStars] = useState<{ [key: number]: boolean }>({});
  const [isEditor3, setIsEditor3] = useState(false);
  const [isEditor, setIsEditor] = useState(false);
  const [isEditor2, setIsEditor2] = useState(false);
  // Call initializeStarsState once when the component mounts
  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const [openModal, setOpenModal] = useState(false);
  const sortbydata = [
    { value: "Sort By Date", label: "Sort By Date" },
    { value: "Ascending", label: "Ascending" },
    { value: "Descending", label: "Descending" },
  ];
  const dealsopen = [
    { value: "choose", label: "Choose" },
    { value: "collins", label: "Collins" },
    { value: "konopelski", label: "Konopelski" },
    { value: "adams", label: "Adams" },
    { value: "schumm", label: "Schumm" },
    { value: "wisozk", label: "Wisozk" },
  ];

  const columns = [
    {
      title: "",
      dataIndex: "",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <h4 className="page-title">Leads Overview </h4>
                  </div>
                  <div className="col-sm-8 text-sm-end">
                  </div>
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <>
            <div className="row">
              <div className="col-md-12">
                {/* Leads User */}
                <div className="contact-head">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <ul className="contact-breadcrumb">
                        <li>
                          <Link to={route.leads}>
                            <i className="ti ti-arrow-narrow-left" />
                            Leads
                          </Link>
                        </li>
                        <li>{lead?.firstName} {lead?.lastName}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body pb-2">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <div className="d-flex align-items-center mb-2">
                        <div className="avatar avatar-xxl me-3 flex-shrink-0 border p-2">
                          <h6 className="text-default fw-medium">HT</h6>
                        </div>
                        <div>
                          <h5 className="mb-1 d-flex align-items-center">
                            <span>{lead?.firstName} {lead?.lastName}</span>
                            <div className="dropdown table-action ms-auto">
                              <Link
                                to="#"
                                className="action-icon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="fa fa-ellipsis-v"></i>
                              </Link>
                              <div
                                className="dropdown-menu dropdown-menu-right"
                                style={{
                                  position: "absolute",
                                  inset: "0px auto auto 0px",
                                  margin: "0px",
                                  transform: "translate3d(-99.3333px, 35.3333px, 0px)",
                                }}
                                data-popper-placement="bottom-start"
                              >
                                {/* Edit Action */}
                                <Link
                                  className="dropdown-item edit-popup"
                                  to="#"
                                  onClick={() => uuid && handleEditClick(uuid)}
                                >
                                  <i className="ti ti-edit text-blue"></i> Edit
                                </Link>

                                {/* Delete Action */}
                                <Link
                                  className="dropdown-item"
                                  to="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete_lead"
                                  onClick={() => lead?.id && handleDeleteClick(lead.id, lead.firstName)}
                                >
                                  <i className="ti ti-trash text-danger"></i> Delete
                                </Link>
                              </div>
                            </div>
                          </h5>

                          <p className="mb-1">
                            <i className="ti ti-building me-1" />
                            {lead?.company || "N/A"}
                          </p>

                          <p className="mb-0">
                            <i className="ti ti-map-pin-pin me-1" />
                            {lead?.street || ""}, {lead?.city || ""}, {lead?.state || ""}, {lead?.country || ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Leads User */}
              </div>
              {/* Leads Sidebar */}
              <div className="col-xl-3 theiaStickySidebar">
                <div className="card">
                  <div className="card-body p-3">
                    <div className="row mb-3">
                      <h6 className="col-6 fw-semibold">Lead Status</h6>
                      <div className="col-6 d-flex align-items-center">
                        {isEditingStatus ? (
                          <>
                            <select
                              className="form-select me-2"
                              value={selectedStatus}
                              onChange={(e) => setSelectedStatus(Number(e.target.value))}
                            >
                              {statusOptions.map((status: Stage) => (
                                <option key={status.id} value={status.id}>
                                  {status.name}
                                </option>
                              ))}
                            </select>
                            <FaCheck className="text-success me-2" onClick={handleSaveStatus} style={{ cursor: "pointer" }} />
                            <FaTimes className="text-danger" onClick={handleCancelEdit} style={{ cursor: "pointer" }} />
                          </>
                        ) : (
                          <>
                            <span>{lead?.leadStatus || "N/A"}</span>
                            <FaEdit className="ms-2 text-primary" onClick={handleEditStatusClick} style={{ cursor: "pointer" }} />
                          </>
                        )}
                      </div>
                    </div>
                    <h6 className="mb-3 fw-semibold">Lead Information</h6>
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Gender</span>
                        <span className="col-6">{lead?.gender || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Date of Birth</span>
                        <span className="col-6">{lead?.dob ? new Date(lead.dob).toLocaleDateString() : "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Title</span>
                        <span className="col-6">{lead?.title || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Phone</span>
                        <span className="col-6">{lead?.phone || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Mobile</span>
                        <span className="col-6">{lead?.mobile || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Email</span>
                        <span className="col-6">{lead?.email || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Rating</span>
                        <span className="col-6">
                          {ratingOptions.find((option) => Number(option.value) === lead?.rating)?.label || "N/A"}
                        </span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Industry</span>
                        <span className="col-6">{lead?.industry || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">No. of Employees</span>
                        <span className="col-6">{lead?.noOfEmployees || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Source</span>
                        <span className="col-6">{lead?.leadSource || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Website</span>
                        <span className="col-6">{lead?.website || "N/A"}</span>
                      </li><li className="row mb-3">
                        <span className="col-6">Description</span>
                        <span className="col-6">{lead?.description || "N/A"}</span>
                      </li>
                      <li className="row mb-3">
                        <span className="col-6">Languague</span>
                        <span className="col-6">{lead?.language || "N/A"}</span>
                      </li>
                    </ul>
                    <h6 className="mb-3 fw-semibold">Owner</h6>
                    <div className="d-flex align-items-center mb-3">
                      <p>{lead?.owner?.name || "N/A"}</p>
                    </div>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Tags</h6>
                    <div>
                      {lead?.tags && lead.tags.length > 0 ? (
                        lead.tags.map((tag, index) => (
                          <Link
                            key={index}
                            to={`/tags/detail/${tag.tagId}`}
                            className="badge badge-soft-success fw-medium me-2"
                          >
                            {tag.name}
                          </Link>
                        ))
                      ) : (
                        <p className="text-muted">No tags available</p>
                      )}
                    </div>
                    <hr />
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Create At</span>
                        <span className="col-6">{lead?.createdAt ? new Date(lead.createdAt).toLocaleDateString() : "N/A"}</span>
                      </li>
                      <li className="row mb-0">
                        <span className="col-6">Created By</span>
                        <span className="col-6">
                          {lead?.createdBy || "N/A"}
                        </span>
                      </li>
                    </ul>
                    <hr />
                    <ul>
                      <li className="row mb-3">
                        <span className="col-6">Last Modified</span>
                        <span className="col-6">{lead?.updatedAt ? new Date(lead.updatedAt).toLocaleDateString() : "N/A"}</span>
                      </li>
                      <li className="row mb-0">
                        <span className="col-6">Modified By</span>
                        <span className="col-6">
                          {lead?.updatedBy || "N/A"}
                        </span>
                      </li>
                    </ul>
                    <hr />
                    <h6 className="mb-3 fw-semibold">Social Profile</h6>
                    <ul className="social-info">
                      <li>
                        <a href={getValidUrl(lead?.facebook)} target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href={getValidUrl(lead?.skype)} target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-skype" />
                        </a>
                      </li>
                      <li>
                        <a href={getValidUrl(lead?.linkedin)} target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-linkedin" />
                        </a>
                      </li>
                      <li>
                        <a href={getValidUrl(lead?.twitter)} target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a href={getValidUrl(lead?.instagram)} target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a href={getValidUrl(lead?.whatsapp)} target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-whatsapp" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Leads Sidebar */}
              {/* Leads Details */}
              <div className="col-xl-9">
                <div className="card mb-3">
                  <div className="card-body pb-0">
                    <h4 className="fw-semibold mb-3">Lead Pipeline Status</h4>
                    <div className="pipeline-list">
                      <ul>
                        {stages.length > 0 ? (
                          stages.map((stage, index) => (
                            <li key={stage.id}>
                              <Link
                                to="#"
                                className={stage.id === selectedStatus ? `bg-${getStageColor(index)}` : "bg-gray-300"}
                                onClick={() => handleStageClick(stage.id)}
                              >
                                {stage.name}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <p>No stages available</p>
                        )}
                      </ul>
                    </div>
                    <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#activities"
                          className="nav-link active"
                          onClick={() => setReloadActivity(!reloadActivity)}
                        >
                          <i className="ti ti-alarm-minus me-1" />
                          Activities
                        </Link>
                      </li>
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#tasks"
                          className="nav-link"
                        >
                          <i className="ti ti-list-check me-1" />
                          Tasks
                        </Link>
                      </li>
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#events"
                          className="nav-link"
                        >
                          <i className="ti ti-calendar-event me-1" />
                          Events
                        </Link>
                      </li>
                      <li className="nav-item" role="presentation">
                        <Link
                          to="#"
                          data-bs-toggle="tab"
                          data-bs-target="#calls"
                          className="nav-link"
                        >
                          <i className="ti ti-phone me-1" />
                          Calls
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Edit Lead */}
                <Offcanvas show={show3} onHide={handleClose3} placement="end">
                  <div className="offcanvas-header border-bottom">
                    <h5 className="fw-semibold">Update Lead</h5>
                    <button
                      type="button"
                      className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                      onClick={handleClose3}
                      aria-label="Close"
                    >
                      <i className="ti ti-x" />
                    </button>
                  </div>
                  <div className="offcanvas-body">
                    <form>
                      <div className="accordion" id="main_accordion">
                        {/* Basic Info */}
                        <div className="accordion-item rounded mb-3">
                          <div className="accordion-header">
                            <Link
                              to="#"
                              className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                              data-bs-toggle="collapse"
                              data-bs-target="#basic"
                            >
                              <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-user-plus fs-20" />
                              </span>
                              Basic Info
                            </Link>
                          </div>
                          <div
                            className="accordion-collapse collapse show"
                            id="basic"
                            data-bs-parent="#main_accordion"
                          >
                            <div className="accordion-body border-top">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="mb-3">
                                    <label className="col-form-label">Salutation</label>
                                    <Select
                                      className="select2"
                                      options={optionSalutation}
                                      classNamePrefix="react-select"
                                      value={optionSalutation.find(
                                        (option) => option.value === editingLead?.salutation
                                      )}
                                      onChange={(selectedOption) =>
                                        handleSelectChangeEdit(selectedOption, "salutation")
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      First Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="firstName"
                                      value={editingLead?.firstName || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.firstName && <small className="text-danger">{errorsEditForm.firstName}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Last Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="lastName"
                                      value={editingLead?.lastName || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.lastName && <small className="text-danger">{errorsEditForm.lastName}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Gender
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="icon-form-end">
                                      <span className="form-icon">
                                        <i className="ti ti-star" />
                                      </span>
                                      <Select
                                        className="select2"
                                        options={genderOptions}
                                        classNamePrefix="react-select"
                                        value={genderOptions.find(
                                          (option) => (option.value) === editingLead?.gender
                                        )}
                                        onChange={(selectedOption) =>
                                          handleSelectChangeEdit(selectedOption, "gender")
                                        }
                                      />
                                      {errorsEditForm.gender && <small className="text-danger">{errorsEditForm.gender}</small>}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Date of Birth <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="date"
                                      className="form-control"
                                      name="dob"
                                      value={editingLead?.dob || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.dob && <small className="text-danger">{errorsEditForm.dob}</small>}
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Company Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="company"
                                      value={editingLead?.company || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.company && <small className="text-danger">{errorsEditForm.company}</small>}
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Email <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="email"
                                      value={editingLead?.email || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.email && <small className="text-danger">{errorsEditForm.email}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Phone <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="phone"
                                      value={editingLead?.phone || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.phone && <small className="text-danger">{errorsEditForm.phone}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Mobile</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="mobile"
                                      value={editingLead?.mobile || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.mobile && <small className="text-danger">{errorsEditForm.mobile}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Website
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="website"
                                      value={editingLead?.website || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.website && <small className="text-danger">{errorsEditForm.website}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Ratings</label>
                                    <div className="icon-form-end">
                                      <span className="form-icon">
                                        <i className="ti ti-star" />
                                      </span>
                                      <Select
                                        className="select2"
                                        options={ratingOptions}
                                        classNamePrefix="react-select"
                                        value={ratingOptions.find(
                                          (option) => Number(option.value) === editingLead?.rating
                                        )}
                                        onChange={(selectedOption) =>
                                          handleSelectChangeEdit(selectedOption, "rating")
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Owner</label><span className="text-danger">*</span>
                                    <Select
                                      className="select2"
                                      options={ownerOptions}
                                      classNamePrefix="react-select"
                                      value={selectedOwners}
                                      onChange={(selectedOption) => {
                                        setSelectedOwners(selectedOption ? [selectedOption] : []);
                                        setEditingLead((prevState) => {
                                          if (!prevState) return null;
                                          return {
                                            ...prevState,
                                            owner: selectedOption
                                              ? {
                                                id: Number(selectedOption.value),
                                                uuid: selectedOption.value,
                                                name: selectedOption.label,
                                              }
                                              : undefined,
                                          };
                                        });
                                      }}
                                      placeholder="Select Owner"
                                    />
                                    {errorsEditForm.owner && <small className="text-danger">{errorsEditForm.owner}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Status</label><span className="text-danger">*</span>
                                    <select
                                      className="form-select"
                                      value={selectedStatus}
                                      onChange={(e) => {
                                        const newStatusId = Number(e.target.value);
                                        setSelectedStatus(newStatusId);

                                        setEditingLead((prevLead) =>
                                          prevLead
                                            ? {
                                              ...prevLead,
                                              statusDto: {
                                                ...prevLead.statusDto,
                                                statusId: newStatusId,
                                              },
                                              leadStageId: newStatusId,
                                            }
                                            : null
                                        );
                                      }}
                                    >
                                      <option value="">Select Status</option>
                                      {statusOptions.map((status) => (
                                        <option key={status.id} value={status.id}>
                                          {status.name}
                                        </option>
                                      ))}
                                    </select>
                                    {errorsEditForm.status && <small className="text-danger">{errorsEditForm.status}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Tags</label>
                                    <Select
                                      isMulti
                                      options={allTags.map(tag => ({
                                        value: tag.id,
                                        label: tag.name
                                      }))}
                                      value={editingLead?.tags?.map(tag => ({
                                        value: tag.tagId,
                                        label: tag.name
                                      })) || []}
                                      onChange={handleTagChange}
                                      styles={{
                                        control: (provided, state) => ({
                                          ...provided,
                                          minHeight: "50px",
                                          maxHeight: "auto",
                                          overflowY: "auto",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                      }}
                                    />

                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Title</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="title"
                                      value={editingLead?.title || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.title && <small className="text-danger">{errorsEditForm.title}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Source</label>
                                    <Select
                                      className="select2"
                                      options={optionsource}
                                      classNamePrefix="react-select"
                                      value={optionsource.find(
                                        (option) => option.value === editingLead?.leadSource
                                      )}
                                      onChange={(selectedOption) =>
                                        handleSelectChangeEdit(selectedOption, "leadSource")
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Industry</label>
                                    <Select
                                      className="select2"
                                      options={optionindustry}
                                      classNamePrefix="react-select"
                                      value={optionindustry.find(
                                        (option) => option.value === editingLead?.industry
                                      )}
                                      onChange={(selectedOption) =>
                                        handleSelectChangeEdit(selectedOption, "industry")
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">No. of Employees</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="noOfEmployees"
                                      value={editingLead?.noOfEmployees || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.noE && <small className="text-danger">{errorsEditForm.noE}</small>}
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="mb-3">
                                    <label className="col-form-label">Language</label>
                                    <Select
                                      className="select"
                                      options={languageOptions}
                                      value={languageOptions.find(
                                        (option) => option.value === editingLead?.language
                                      )}
                                      onChange={(selectedOption) =>
                                        handleSelectChangeEdit(selectedOption, "language")
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="mb-0">
                                    <label className="col-form-label">Description</label>
                                    <textarea
                                      className="form-control"
                                      rows={5}
                                      name="description"
                                      value={editingLead?.description || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.description && <small className="text-danger">{errorsEditForm.description}</small>}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /Basic Info */}

                        {/* Address Info */}
                        <div className="accordion-item border-top rounded mb-3">
                          <div className="accordion-header">
                            <Link
                              to="#"
                              className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                              data-bs-toggle="collapse"
                              data-bs-target="#address"
                            >
                              <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-map-pin-cog fs-20" />
                              </span>
                              Address Info
                            </Link>
                          </div>
                          <div
                            className="accordion-collapse collapse"
                            id="address"
                            data-bs-parent="#main_accordion"
                          >
                            <div className="accordion-body border-top">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="mb-3">
                                    <label className="col-form-label">Street Address</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="street"
                                      value={editingLead?.street || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.street && <small className="text-danger">{errorsEditForm.street}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">City</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="city"
                                      value={editingLead?.city || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.city && <small className="text-danger">{errorsEditForm.city}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">State / Province</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="state"
                                      value={editingLead?.state || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.state && <small className="text-danger">{errorsEditForm.state}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Country</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="country"
                                      value={editingLead?.country || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.country && <small className="text-danger">{errorsEditForm.country}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-0">
                                    <label className="col-form-label">Zipcode</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="zip"
                                      value={editingLead?.zip || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.zip && <small className="text-danger">{errorsEditForm.zip}</small>}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /Address Info */}

                        {/* Social Profile */}
                        <div className="accordion-item border-top rounded mb-3">
                          <div className="accordion-header">
                            <Link
                              to="#"
                              className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                              data-bs-toggle="collapse"
                              data-bs-target="#social"
                            >
                              <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-social fs-20" />
                              </span>
                              Social Profile
                            </Link>
                          </div>
                          <div
                            className="accordion-collapse collapse"
                            id="social"
                            data-bs-parent="#main_accordion"
                          >
                            <div className="accordion-body border-top">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Facebook</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="facebook"
                                      value={editingLead?.facebook || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.facebook && <small className="text-danger">{errorsEditForm.facebook}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Skype</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="skype"
                                      value={editingLead?.skype || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.skype && <small className="text-danger">{errorsEditForm.skype}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Linkedin</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="linkedin"
                                      value={editingLead?.linkedin || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.linkedin && <small className="text-danger">{errorsEditForm.linkedin}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">Twitter</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="twitter"
                                      value={editingLead?.twitter || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.twitter && <small className="text-danger">{errorsEditForm.twitter}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3 mb-md-0">
                                    <label className="col-form-label">Whatsapp</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="whatsapp"
                                      value={editingLead?.whatsapp || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.whatsapp && <small className="text-danger">{errorsEditForm.whatsapp}</small>}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-0">
                                    <label className="col-form-label">Instagram</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="instagram"
                                      value={editingLead?.instagram || ""}
                                      onChange={handleInputChange}
                                    />
                                    {errorsEditForm.instagram && <small className="text-danger">{errorsEditForm.instagram}</small>}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /Social Profile */}
                      </div>
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          data-bs-dismiss="offcanvas"
                          className="btn btn-light me-2"
                          onClick={handleClose3}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleUpdateLead}
                        >
                          Edit
                        </button>
                      </div>
                    </form>
                  </div>
                </Offcanvas>
                {/* Edit Lead */}
                {/* Edit Lead Success Modal */}
                <Modal show={openEditSuccessModal} onHide={() => setOpenEditSuccessModal(false)}>
                  <div className="modal-body">
                    <div className="success-message text-center">
                      <div className="success-popup-icon bg-light-blue">
                        <i className="ti ti-chart-arcs" />
                      </div>
                      <h3>Leads Created Successfully!!!</h3>
                      <div className="col-lg-12 text-center modal-btn">
                        <Link
                          to={`/leads-details/${editedLeadUuid}`}
                          onClick={() => {
                            setOpenEditSuccessModal(false);
                          }}
                          className="btn btn-primary"
                        >
                          Ok
                        </Link>
                      </div>
                    </div>
                  </div>
                </Modal>
                {/* /Edit Lead Success Modal */}
                {/* Delete Lead */}
                <div className="modal fade" id="delete_lead" role="dialog">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-body">
                        <div className="text-center">
                          <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                            <i className="ti ti-trash-x fs-36 text-danger" />
                          </div>
                          <h4 className="mb-2">Remove Lead?</h4>
                          <p className="mb-0">
                            Are you sure you want to remove <br />
                            lead <strong>{leadToDelete?.name}</strong>?
                          </p>
                          <div className="d-flex align-items-center justify-content-center mt-4">
                            <Link
                              to="#"
                              className="btn btn-light me-2"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </Link>
                            <button
                              data-bs-dismiss="modal"
                              className="btn btn-danger"
                              onClick={handleConfirmDelete}
                            >
                              Yes, Delete {leadToDelete?.name}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Delete Lead */}
                {/* Tab Content */}
                <div className="tab-content pt-0">
                  {/* Activities */}
                  {lead && <ActivityList id={lead.id} type={ACTIVITY_TYPES.LEAD} reload={reloadActivity} />}
                  {/* /Activities */}
                  {/* Events */}
                  <div className="tab-pane fade" id="events">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h4 className="fw-semibold">Events</h4>
                        <div className="d-inline-flex align-items-center">
                          <button
                            className="btn btn-primary me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#create_event"
                          >
                            <i className="ti ti-plus"></i> Add New Event
                          </button>
                          <div className="form-sort mt-0">
                            <i className="ti ti-sort-ascending-2" />
                            <Select
                              className="select"
                              options={ascendingandDecending}
                              placeholder="Ascending"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {loading ? (
                          <p>Loading events...</p>
                        ) : error ? (
                          <p className="text-danger">{error}</p>
                        ) : events.length === 0 ? (
                          <div className="text-center p-5">
                            <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                              <i className="ti ti-calendar-event fs-24 text-primary"></i>
                            </div>
                            <h5>No events yet</h5>
                            <p className="text-muted">Create your first event by clicking the button above</p>
                          </div>
                        ) : (
                          events.map((event) => (
                            <div key={event.id} className="card border shadow-none mb-3">
                              <div className="card-body p-3">
                                <div className="d-flex">
                                  <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-success">
                                    <i className="ti ti-calendar-event text-white"></i>
                                  </span>
                                  <div className="w-100">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                      <h6 className="fw-medium mb-0">Subject : {event.subject}</h6>
                                      <div className="dropdown">
                                        <Link
                                          to="#"
                                          className="action-icon"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i className="fa fa-ellipsis-v"></i>
                                        </Link>
                                        <div className="dropdown-menu dropdown-menu-right">
                                          <Link
                                            to="#"
                                            className="dropdown-item"
                                            data-bs-toggle="modal"
                                            data-bs-target="#edit_event"
                                            onClick={() => handleEditClickEvent(event.id)}
                                          >
                                            <i className="ti ti-edit text-blue"></i> Edit
                                          </Link>
                                          <Link
                                            to="#"
                                            className="dropdown-item"
                                            onClick={() => handleDeleteEventClick(event.id)}
                                          >
                                            <i className="ti ti-trash text-danger"></i> Delete
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                    <p className="mb-1">Description: {event.description || "No description"}</p>
                                    <div className="d-flex flex-wrap gap-2 mb-1">
                                      <span className="badge bg-success">
                                        Start Time: {new Date(event.startTime).toLocaleString()}
                                      </span>
                                      <span className="badge bg-danger">
                                        End Time: {new Date(event.endTime).toLocaleString()}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>

                    </div>
                  </div>
                  {/* Events */}
                  {/* Calls */}
                  <div className="tab-pane fade" id="calls">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h4 className="fw-semibold">Calls</h4>
                        <div>
                          <div className="d-flex">
                            <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#create_call">
                              <i className="ti ti-plus"></i> Add New Log Call
                            </button>
                            <div className="form-sort mt-0">
                              <i className="ti ti-sort-ascending-2" />
                              <Select
                                className="select"
                                options={ascendingandDecending}
                                placeholder="Ascending"
                                classNamePrefix="react-select"
                              />
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="card-body">
                        {logCalls.length > 0 ? (
                          logCalls.map((call, index) => (
                            <div key={index} className="card border shadow-none mb-3">
                              <div className="card-body p-3">
                                <div className="d-flex">
                                  <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-secondary-success">
                                    <i className="ti ti-phone" />
                                  </span>
                                  <div className="w-100">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                      <div>
                                        <span className="badge bg-primary me-2">{call.userCall || 'Unknown User'}</span>
                                        <span
                                          className={`badge ${call.status === 'BUSY' ? 'bg-danger' :
                                            call.status === 'NO_ANSWER' ? 'bg-warning' :
                                              call.status === 'LEFT_VOICE_MESSAGE' ? 'bg-info' :
                                                call.status === 'MOVING_FORWARD' ? 'bg-success' :
                                                  'bg-secondary'
                                            }`}
                                        >
                                          {call.status?.replace(/_/g, ' ')}
                                        </span>
                                      </div>
                                      <div className="dropdown">
                                        <Link
                                          to="#"
                                          className="action-icon"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i className="fa fa-ellipsis-v"></i>
                                        </Link>
                                        <div className="dropdown-menu dropdown-menu-right">
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#edit_call"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleEditClickLogCall(call.id);
                                            }}
                                          >
                                            <i className="ti ti-edit text-blue me-1" />
                                            Edit
                                          </Link>
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#delete_logcall"
                                            className="dropdown-item"
                                            onClick={() => handleDeleteClickLogCall(call.id)}
                                          >
                                            <i className="ti ti-trash text-danger me-1" />
                                            Delete
                                          </Link>

                                        </div>
                                      </div>
                                    </div>
                                    <p className="mb-1">{call.notes || 'No notes'}</p>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div>
                                        <p className="mb-0 text-muted small">
                                          <i className="ti ti-calendar me-1"></i>
                                          {call.callTime ? `Call time: ${new Date(call.callTime).toLocaleString()}` : 'No call time'}
                                        </p>
                                        <p className="mb-0 text-muted small">
                                          <i className="ti ti-calendar-event me-1"></i>
                                          {call.followUpTime ? `Follow-up: ${new Date(call.followUpTime).toLocaleString()}` : 'No follow-up'}
                                        </p>
                                      </div>
                                      <div className="dropdown">
                                        <button
                                          className={`btn btn-sm ${call.status === 'BUSY' ? 'btn-danger' :
                                            call.status === 'NO_ANSWER' ? 'btn-warning' :
                                              call.status === 'LEFT_VOICE_MESSAGE' ? 'btn-info' :
                                                call.status === 'MOVING_FORWARD' ? 'btn-success' :
                                                  'btn-secondary'
                                            } dropdown-toggle`}
                                          data-bs-toggle="dropdown"
                                        >
                                          {call.status?.replace(/_/g, ' ')}
                                        </button>
                                        <div className="dropdown-menu">
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'BUSY')}
                                          >
                                            Busy
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'NO_ANSWER')}
                                          >
                                            No Answer
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'UNAVAILABLE')}
                                          >
                                            Unavailable
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'WRONG_NUMBER')}
                                          >
                                            Wrong Number
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'LEFT_VOICE_MESSAGE')}
                                          >
                                            Left Voice Message
                                          </Link>
                                          <Link
                                            className="dropdown-item"
                                            to="#"
                                            onClick={() => handleUpdateLogCallStatus(call.id, 'MOVING_FORWARD')}
                                          >
                                            Moving Forward
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-center p-5">
                            <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                              <i className="ti ti-phone-call fs-24 text-primary"></i>
                            </div>
                            <h5>No calls logged yet</h5>
                            <p className="text-muted">Log your first call by clicking the button above</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* /Calls */}
                  {/* Tasks */}
                  <div className="tab-pane fade" id="tasks">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h4 className="fw-semibold">Tasks</h4>
                        <div>
                          <div className="d-flex">
                            <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#create_task">
                              <i className="ti ti-plus"></i> Add New Task
                            </button>
                            <div className="form-sort mt-0">
                              <i className="ti ti-sort-ascending-2" />
                              <Select
                                className="select"
                                options={ascendingandDecending}
                                placeholder="Ascending"
                                classNamePrefix="react-select"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {/* Task list section */}
                        {tasks.length > 0 ? (
                          tasks.map((task, index) => (
                            <div key={index} className="card border shadow-none mb-3">
                              <div className="card-body p-3">
                                <div className="d-flex">
                                  <span className="avatar avatar-md flex-shrink-0 rounded me-2 bg-info">
                                    <i className="ti ti-notes" />
                                  </span>
                                  <div className="w-100">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                      <h6 className="fw-medium mb-0">{task.title}</h6>
                                      <div className="dropdown">
                                        <Link
                                          to="#"
                                          className="action-icon"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i className="fa fa-ellipsis-v"></i>
                                        </Link>
                                        <div className="dropdown-menu dropdown-menu-right">
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#edit_task"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleEditClickTask(task.id);
                                            }}
                                          >
                                            <i className="ti ti-edit text-blue"></i> Edit
                                          </Link>
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#delete_task"
                                            className="dropdown-item"
                                            onClick={() => handleDeleteClickTask(task.id)}
                                          >
                                            <i className="ti ti-trash text-danger me-1" />
                                            Delete
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                    <p className="mb-1">{task.description || 'No description'}</p>
                                    <div className="d-flex flex-wrap gap-2 mb-1">
                                      <span className="badge bg-info">Status: {task.status}</span>
                                      <span className="badge bg-warning">Priority: {task.priority}</span>
                                      <span className="badge bg-secondary">Category: {task.category}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <p className="mb-0 text-muted small">
                                        <i className="ti ti-calendar me-1"></i>
                                        Start: {new Date(task.startDate).toLocaleString()}
                                        {task.endDate ? ` | End: ${new Date(task.endDate).toLocaleString()}` : ' | No end date'}
                                      </p>
                                      <p className="mb-0 text-muted small">
                                        <i className="ti ti-user me-1"></i>
                                        {task.responsible.username || 'No responsible'}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-center p-3">
                            <div className="avatar avatar-lg bg-light-primary rounded-circle mb-2">
                              <i className="ti ti-list-check fs-24 text-primary"></i>
                            </div>
                            <h5>No tasks found</h5>
                            <p className="text-muted">Create a new task to get started</p>
                          </div>
                        )}
                      </div>
                      {/* /Recent Task List */}
                    </div>
                  </div>
                  {/* /Tasks */}
                </div>
                {/* /Tab Content */}
              </div>
              {/* /Leads Details */}
            </div>
          </>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Create Contact */}
      <div className="modal custom-modal fade" id="create_contact" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-user-plus" />
                </div>
                <h3>Contact Created Successfully!!!</h3>
                <p>View the details of contact, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <Link to={route.dealsDetails} className="btn btn-primary">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Contact */}
      {/* Add Event */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_event"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Event</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter subject"
                        value={newEventData.subject}
                        onChange={(e) => setNewEventData({ ...newEventData, subject: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Enter description"
                        value={newEventData.description}
                        onChange={(e) => setNewEventData({ ...newEventData, description: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Location</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter location"
                        value={newEventData.location}
                        onChange={(e) => setNewEventData({ ...newEventData, location: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Attendees</label>
                      <Select
                        isMulti
                        options={attendeesOptions}
                        value={attendees}
                        onChange={handleSelectAttendeesChange}
                        classNamePrefix="react-select"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "50px",
                            maxHeight: "none",
                            flexWrap: "wrap",
                            overflowY: "auto",
                          }),
                          valueContainer: (provided) => ({
                            ...provided,
                            flexWrap: "wrap",
                            maxHeight: "150px",
                            overflowY: "auto",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Involve Type</label>
                        <select
                          className="form-control"
                          value={newEventData.assignType}
                          disabled={true}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">Involve</label>
                        <Select
                          isMulti
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.filter(option =>
                            newEventData.assigneeId && Array.isArray(newEventData.assigneeId)
                              ? newEventData.assigneeId.includes(option.value)
                              : false
                          )}
                          onChange={(selectedOptions: MultiValue<{ value: number; label: string }>) =>
                            setNewEventData({
                              ...newEventData,
                              assigneeId: selectedOptions.length > 0
                                ? selectedOptions.map((option) => option.value)
                                : [],
                            })
                          }
                          isDisabled={assignTaskOptions.length == 0}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "50px",
                              maxHeight: "none",
                              flexWrap: "wrap",
                              overflowY: "auto",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              flexWrap: "wrap",
                              maxHeight: "150px",
                              overflowY: "auto",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newEventData.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newEventData.targetIds) || null}
                          onChange={(selectedOption) => setNewEventData({ ...newEventData, targetIds: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <label className="col-form-label">Start Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={newEventData.startTime}
                          onChange={(e) => setNewEventData({ ...newEventData, startTime: e.target.value })}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="col-form-label">End Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={newEventData.endTime}
                          onChange={(e) => setNewEventData({ ...newEventData, endTime: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="text-end modal-btn mt-3">
                      <button
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                        type="button"
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleCreateEvent}>
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* /Add Event */}
      {/* /Update Event */}
      <div
        className="modal custom-modal fade modal-padding"
        id="edit_event"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Event</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter subject"
                        value={editEventData.subject}
                        onChange={(e) => setEditEventData({ ...editEventData, subject: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Enter description"
                        value={editEventData.description}
                        onChange={(e) => setEditEventData({ ...editEventData, description: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Location</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter location"
                        value={editEventData.location}
                        onChange={(e) => setEditEventData({ ...editEventData, location: e.target.value })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">Attendees</label>
                      <Select
                        isMulti
                        options={attendeesOptions}
                        value={selectedAttendees}
                        onChange={handleSelectAttendeesChange}
                        classNamePrefix="react-select"
                      />
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Involve Type</label>
                        <select
                          className="form-control"
                          value={editEventData.assignType}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">Involve</label>
                        <Select
                          isMulti
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.filter(option => editEventData.assigneeId.includes(option.value))}
                          onChange={(selectedOptions: MultiValue<{ value: number; label: string }>) =>
                            setEditEventData({
                              ...editEventData,
                              assigneeId: selectedOptions.map((option) => option.value),
                            })
                          }
                          isDisabled={assignTaskOptions.length === 0}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "50px",
                              maxHeight: "auto",
                              overflowY: "auto",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={editEventData?.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>
                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === editEventData.targetIds)}
                          onChange={(selectedOption) => setEditEventData({ ...editEventData, targetIds: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <label className="col-form-label">Start Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={editEventData.startTime}
                          onChange={(e) => setEditEventData({ ...editEventData, startTime: e.target.value })}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="col-form-label">End Time</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          value={editEventData.endTime}
                          onChange={(e) => setEditEventData({ ...editEventData, endTime: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="text-end modal-btn mt-3">
                      <button
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                        type="button"
                      >
                        Cancel
                      </button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleUpdateEvent}>
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Update Event */}
      {/* Create Task */}
      <div className="modal custom-modal fade modal-padding" id="create_task" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Task</h5>
              <button type="button" className="btn-close position-static" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    {/* Title */}
                    <div className="mb-3">
                      <label className="col-form-label">Title <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={newTaskData.title}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Category */}
                    <div className="mb-3">
                      <label className="col-form-label">Category</label>
                      <Select
                        options={selectTaskCategoryOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.category ? { label: newTaskData.category, value: newTaskData.category } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, category: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Responsible */}
                    <div className="mb-3">
                      <label className="col-form-label">Responsible</label>
                      <select
                        className="form-control"
                        name="responsible"
                        value={newTaskData.responsible}
                        disabled={true}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled>Select Responsible</option>
                        {listUserCall.map((user) => (
                          <option key={user.uuid} value={user.uuid}>
                            {user.username}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Assign Type */}
                    <div className="row">
                      {/* Assign Type */}
                      <div className="col-md-6">
                        <label className="col-form-label">Involve Type</label>
                        <select
                          className="form-control"
                          value={newTaskData.assignType}
                          disabled={true}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Involve</label>
                        <Select
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.find(option => option.value === newTaskData.assignId) || null}
                          onChange={(selectedOption) => setNewTaskData({ ...newTaskData, assignId: selectedOption?.value || 0 })}
                          isDisabled={true}
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newTaskData.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newTaskData.targetId) || null}
                          onChange={(selectedOption) => setNewTaskData({ ...newTaskData, targetId: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>


                    <div className="row">
                      {/* Start Date */}
                      <div className="mb-6">
                        <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="startDate"
                          value={newTaskData.startDate}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* End Date */}
                      <div className="mb-6">
                        <label className="col-form-label">End Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="endDate"
                          value={newTaskData.endDate}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="mb-3">
                      <label className="col-form-label">Status <span className="text-danger">*</span></label>
                      <Select
                        options={selectTaskStatusOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.status ? { label: newTaskData.status, value: newTaskData.status } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, status: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Priority */}
                    <div className="mb-3">
                      <label className="col-form-label">Priority</label>
                      <Select
                        options={selectTaskPriorityOptions}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        value={newTaskData.priority ? { label: newTaskData.priority, value: newTaskData.priority } : null}
                        onChange={(selectedOption) => setNewTaskData({ ...newTaskData, priority: selectedOption?.value || "" })}
                      />
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        rows={4}
                        value={newTaskData.description}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Confirm & Cancel Buttons */}
                    <div className="text-end modal-btn">
                      <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button" onClick={handleCreateTasks}>
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Create Task */}
      {/*Update Task*/}
      <div className="modal custom-modal fade modal-padding" id="edit_task" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Task</h5>
              <button type="button" className="btn-close position-static" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    {/* Title */}
                    <div className="mb-3">
                      <label className="col-form-label">Title <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name="title" value={editTaskData?.title || ""} onChange={handleUpdateTaskInputChange} />
                    </div>

                    {/* Category */}
                    <div className="mb-3">
                      <label className="col-form-label">Category</label>
                      <Select
                        options={selectTaskCategoryOptions}
                        placeholder="Choose"
                        name="category"
                        value={selectTaskCategoryOptions.find(opt => opt.value === editTaskData?.category)}
                        onChange={(option) => handleUpdateTaskSelectChange("category", option?.value ?? "")}
                        classNamePrefix="react-select"
                      />
                    </div>

                    {/* Responsible */}
                    <div className="mb-3">
                      <label className="col-form-label">Responsible</label>
                      <select className="form-control" name="responsible" disabled={true} value={editTaskData?.responsible || ""} onChange={handleUpdateTaskInputChange}>
                        <option value="" disabled>Select Responsible</option>
                        {listUserCall.map(user => (
                          <option key={user.uuid} value={user.uuid}>{user.username}</option>
                        ))}
                      </select>
                    </div>
                    {/* Assign Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select className="form-control" name="assignType" disabled={true} value={selectAssignType.find(option => option.value === editTaskData?.assignType)?.value || "LEAD"} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          options={assignTaskOptions}
                          placeholder="Choose"
                          value={assignTaskOptions.find(opt => opt.value === editTaskData.assignId) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("assignId", option?.value || 0)}
                          isDisabled={true}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select className="form-control" name="targetType" disabled={true} value={editTaskData?.targetType || ""} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target ID */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          options={relateTaskOptions}
                          placeholder="Choose"
                          value={relateTaskOptions.find(opt => opt.value === editTaskData?.targetId) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("targetId", option?.value ?? 0)}
                          isDisabled={true}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    <div className="row">
                      {/* Start Date */}
                      <div className="mb-6">
                        <label className="col-form-label">Start Date <span className="text-danger">*</span></label>
                        <input type="datetime-local" className="form-control" name="startDate" value={editTaskData?.startDate || ""} onChange={handleUpdateTaskInputChange} />
                      </div>

                      {/* End Date */}
                      <div className="mb-6">
                        <label className="col-form-label">End Date</label>
                        <input type="datetime-local" className="form-control" name="endDate" value={editTaskData?.endDate || ""} onChange={handleUpdateTaskInputChange} />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="mb-3">
                      <label className="col-form-label">Status <span className="text-danger">*</span></label>
                      <Select options={selectTaskStatusOptions}
                        value={selectTaskStatusOptions.find(opt => opt.value === editTaskData?.status)}
                        onChange={(option) => handleUpdateTaskSelectChange("status", option?.value || "")} />
                    </div>

                    {/* Priority */}
                    <div className="mb-3">
                      <label className="col-form-label">Priority</label>
                      <Select options={selectTaskPriorityOptions} placeholder="Choose"
                        value={selectTaskPriorityOptions.find(opt => opt.value === editTaskData?.priority)}
                        onChange={(option) => handleUpdateTaskSelectChange("priority", option?.value || "")} classNamePrefix="react-select" />
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                      <label className="col-form-label">Description</label>
                      <textarea className="form-control" rows={4} name="description" value={editTaskData?.description || ""} onChange={handleUpdateTaskInputChange} />
                    </div>

                    {/* Confirm & Cancel Buttons */}
                    <div className="text-end modal-btn">
                      <button className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="button"
                        onClick={() => selectedTaskId?.id && handleUpdateTask(selectedTaskId?.id)}
                      >
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/*Update Task*/}
      {/* Create Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="create_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        User Call <span className="text-danger"> *</span>
                      </label>
                      {loading ? (
                        <div>Loading...</div>
                      ) : error ? (
                        <div className="text-danger">{error}</div>
                      ) : (
                        <select
                          className="form-control"
                          value={newLogCall.userCall}
                          disabled={true}
                          onChange={(e) => setNewLogCall(prev => ({ ...prev, userCall: e.target.value }))}
                        >
                          <option value="" disabled>
                            Select User Call
                          </option>
                          {listUserCall.length > 0 ? (
                            listUserCall.map((user) => (
                              <option key={user.uuid} value={user.uuid}>
                                {user.username}
                              </option>
                            ))
                          ) : (
                            <option value="">No users available</option>
                          )}
                        </select>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        onChange={(selected) => {
                          if (selected) {
                            setNewLogCall((prev) => ({ ...prev, status: selected.value }));
                          }
                        }}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        value={newLogCall.followUpDate}
                        onChange={(e) => setNewLogCall(prev => ({ ...prev, followUpDate: e.target.value }))}
                      />
                    </div>
                    <div className="row">
                      {/* Assign Type */}
                      <div className="col-md-6">
                        <label className="col-form-label">Involve Type</label>
                        <select
                          className="form-control"
                          value={newLogCall.assignType}
                          disabled={true}
                          onChange={handleTaskAssignTypeChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Involve</label>
                        <Select
                          className="select2"
                          options={assignTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={assignTaskOptions.find(option => option.value === newLogCall.assignRecord) || null}
                          onChange={(selectedOption) => setNewLogCall({ ...newLogCall, assignRecord: selectedOption?.value || 0 })}
                          isDisabled={true}
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select
                          className="form-control"
                          value={newLogCall.targetType}
                          onChange={handleTaskRelatedToTypeChange}
                        >
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          className="select2"
                          options={relateTaskOptions}
                          placeholder="Choose"
                          classNamePrefix="react-select"
                          value={relateTaskOptions.find(option => option.value === newLogCall.targetRecord) || null}
                          onChange={(selectedOption) => setNewLogCall({ ...newLogCall, targetRecord: selectedOption?.value || 0 })}
                          isDisabled={relateTaskOptions.length === 0}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        value={newLogCall.note}
                        onChange={(e) => setNewLogCall(prev => ({ ...prev, note: e.target.value }))}
                      />
                    </div>
                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button className="btn btn-primary" data-bs-dismiss="modal" type="button"
                        onClick={handleCreateLogCall}
                      >
                        Confirm
                      </button>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* /Edit Call Log */}
      <div
        className="modal custom-modal fade modal-padding"
        id="edit_call"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Call Log</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label">
                        User Call <span className="text-danger"> *</span>
                      </label>
                      {loading ? (
                        <div>Loading...</div>
                      ) : error ? (
                        <div className="text-danger">{error}</div>
                      ) : (
                        <select
                          className="form-control"
                          value={editLogCall?.userCall || ""}
                          disabled={true}
                          onChange={(e) => handleSelectChange(e, "userCall")}
                        >
                          <option value="" disabled>
                            Select User Call
                          </option>
                          {listUserCall.length > 0 ? (
                            listUserCall.map((user) => (
                              <option key={user.uuid} value={user.uuid}>
                                {user.username}
                              </option>
                            ))
                          ) : (
                            <option value="">No users available</option>
                          )}
                        </select>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={statusList}
                        placeholder="Choose"
                        classNamePrefix="react-select"
                        name="status"
                        value={statusList.find((status) => status.value === editLogCall?.status)}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, "status")}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="col-form-label">
                        Follow Up Date <span className="text-danger"> *</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-check" />
                        </span>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="followUpDate"
                          value={editLogCall?.followUpDate}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Assign Type</label>
                        <select className="form-control" name="assignType" disabled={true} value={selectAssignType.find(option => option.value === editLogCall?.assignType)?.value || "LEAD"} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Assign Type</option>
                          {selectAssignType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Assign */}
                      <div className="col-md-6">
                        <label className="col-form-label">Assign</label>
                        <Select
                          options={assignTaskOptions}
                          placeholder="Choose"
                          value={assignTaskOptions.find(opt => opt.value === editLogCall?.assignRecord) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("assignRecord", option?.value || 0)}
                          isDisabled={true}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    {/* Target Type */}
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label">Target Type</label>
                        <select className="form-control" name="targetType" value={editLogCall?.targetType || ""} onChange={handleUpdateTaskInputChange}>
                          <option value="">Select Target Type</option>
                          {selectRelatedToType.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Target ID */}
                      <div className="col-md-6">
                        <label className="col-form-label">Target</label>
                        <Select
                          options={relateTaskOptions}
                          placeholder="Choose"
                          value={relateTaskOptions.find(opt => opt.value === editLogCall?.targetRecord) || null}
                          onChange={(option) => handleUpdateTaskSelectChange("targetRecord", option?.value ?? 0)}
                          isDisabled={relateTaskOptions.length === 0}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="col-form-label">
                        Note <span className="text-danger"> *</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Add text"
                        name="note"
                        value={editLogCall?.note || ""}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="text-end modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        type="button"
                        onClick={() => selectedLogCallId?.id && handleUpdateLogCall(selectedLogCallId?.id)}
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal custom-modal fade modal-padding"
        id="success_modal"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-success-light rounded-circle mb-3">
                  <i className="ti ti-check-circle fs-36 text-success" />
                </div>
                <h4 className="mb-2">Success!</h4>
                <p className="mb-0">
                  Your action was successfully completed.
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-success"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade modal-padding"
        id="error_modal"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-alert-circle fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Oops! Something went wrong</h4>
                <p className="mb-0">
                  We couldn't complete your request. Please try again later.
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Modal Delete Log Call*/}
      <div
        className="modal custom-modal fade modal-padding"
        id="delete_logcall"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Call Log?</h4>
                <p className="mb-0">
                  Are you sure you want to remove this call log?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={() => handleConfirmDeleteLogCall()}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade modal-padding"
        id="delete_task"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Task?</h4>
                <p className="mb-0">
                  Are you sure you want to remove this task?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                    onClick={() => handleConfirmDeleteTask()}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add File */}
      <div
        className="modal custom-modal fade custom-modal-two modal-padding"
        id="new_file"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create New File</h5>
              <button
                type="button"
                className="btn-close position-static"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="add-info-fieldset">
                <div className="add-details-wizard">
                  <ul className="progress-bar-wizard">
                    <li className="active">
                      <span>
                        <i className="ti ti-file" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Basic Info</h6>
                      </div>
                    </li>
                    <li>
                      <span>
                        <i className="ti ti-circle-plus" />
                      </span>
                      <div className="multi-step-info">
                        <h6>Add Recipient</h6>
                      </div>
                    </li>
                  </ul>
                </div>
                <fieldset id="first-field-file">
                  <form >
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Choose Deal <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={dealsopen}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Document Type{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={documentType}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Owner <span className="text-danger">*</span>
                            </label>
                            <SelectWithImage2 />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Title <span className="text-danger"> *</span>
                            </label>
                            <input className="form-control" type="text" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Locale <span className="text-danger">*</span>
                            </label>
                            <Select
                              className="select2"
                              options={LocaleData}
                              placeholder="Choose"
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4>Signature</h4>
                            <ul className="nav sign-item">
                              <li className="nav-item">
                                <span
                                  className=" mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#nosign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign1"
                                    name="email"
                                  />
                                  <label htmlFor="sign1">
                                    <span className="sign-title">
                                      No Signature
                                    </span>
                                    This document does not require a signature
                                    before acceptance.
                                  </label>
                                </span>
                              </li>
                              <li className="nav-item">
                                <span
                                  className="active mb-0"
                                  data-bs-toggle="tab"
                                  data-bs-target="#use-esign"
                                >
                                  <input
                                    type="radio"
                                    className="status-radio"
                                    id="sign2"
                                    name="email"
                                    defaultChecked
                                  />
                                  <label htmlFor="sign2">
                                    <span className="sign-title">
                                      Use e-signature
                                    </span>
                                    This document require e-signature before
                                    acceptance.
                                  </label>
                                </span>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div
                                className="tab-pane show active"
                                id="use-esign"
                              >
                                <div className="input-block mb-0">
                                  <label className="col-form-label">
                                    Document Signers{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="sign-content">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="mb-3">
                                        <input
                                          className="form-control"
                                          type="text"
                                          placeholder="Enter Name"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="d-flex align-items-center">
                                        <div className="float-none mb-3 me-3 w-100">
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Email Address"
                                          />
                                        </div>
                                        <div className="input-btn mb-3">
                                          <Link to="#" className="add-sign">
                                            <i className="ti ti-circle-plus" />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Content <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Add Content"
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Reset
                          </button>
                          <button
                            className="btn btn-primary wizard-next-btn"
                            type="button"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
                <fieldset>
                  <form >
                    <div className="contact-input-set">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="signature-wrap">
                            <h4 className="mb-2">
                              Send the document to following signers
                            </h4>
                            <p>In order to send the document to the signers</p>
                            <div className="input-block mb-0">
                              <label className="col-form-label">
                                Recipients (Additional recipients)
                              </label>
                            </div>
                            <div className="sign-content">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Enter Name"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="d-flex align-items-center">
                                    <div className="float-none mb-3 me-3 w-100">
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Email Address"
                                      />
                                    </div>
                                    <div className="input-btn mb-3">
                                      <Link to="#" className="add-sign">
                                        <i className="ti ti-circle-plus" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Subject{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter Subject"
                            />
                          </div>
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message Text{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              placeholder="Your document is ready"
                              defaultValue={""}
                            />
                          </div>
                          <button className="btn btn-light mb-3">
                            Send Now
                          </button>
                          <div className="send-success">
                            <p>
                              <i className="ti ti-circle-check" /> Document sent
                              successfully to the selected recipients
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12 text-end form-wizard-button modal-btn">
                          <button className="btn btn-light" type="reset">
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            type="button"
                            data-bs-dismiss="modal"
                          >
                            Save &amp; Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add File */}
      {/* Convert Lead Modal */}
      <Modal show={showConvertModal} onHide={() => handleCloseConvertModal()} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Convert Lead</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">
            <strong>Lead: </strong> {lead?.firstName} {lead?.lastName}
          </p>

          <Form>


            {/* Account Selection */}
            <Form.Group className="mb-3">
              <Form.Label>Company</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  label="Create New Company"
                  name="accountType"
                  value="new"
                  checked={accountType === "new"}
                  onChange={() => {
                    setAccountType("new");
                    setAccountName(lead?.company || "N/A");
                    setSelectedAccount(null);
                    setContactType("new");
                    setOpportunityType("new");
                    setSelectedSalutation(lead?.salutation || "N/A");
                    setContactFirstName(lead?.firstName || "N/A");
                    setContactLastName(lead?.lastName || "N/A");
                    setOpportunityName(lead?.company || "N/A");
                  }}
                />
                <Form.Check
                  type="radio"
                  label="Choose Existing Company"
                  name="accountType"
                  value="existing"
                  checked={accountType === "existing"}
                  onChange={() => {
                    setAccountType("existing");
                    setAccountName(lead?.company || "N/A");
                    setSelectedAccount(null);
                  }}
                />
              </div>

              {accountType === "new" && (
                <Form.Control
                  className="mt-2"
                  type="text"
                  placeholder="Enter Company Name"
                  value={accountName}
                  onChange={(e) => setAccountName(e.target.value)}
                  required
                />
              )}

              {accountType === "existing" && (
                <Select
                  options={accountOptions}
                  isSearchable
                  value={selectedAccount}
                  onChange={(option) => setSelectedAccount(option)}
                />
              )}
            </Form.Group>

            {/* Contact Selection */}
            <Form.Group className="mb-3">
              <Form.Label>Contact</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  label="Create New Contact"
                  name="contactType"
                  value="new"
                  checked={contactType === "new"}
                  disabled={accountType === "new"}
                  onChange={() => {
                    setContactType("new");
                    setSelectedSalutation(lead?.salutation || "N/A");
                    setContactFirstName(lead?.firstName || "N/A");
                    setContactLastName(lead?.lastName || "N/A");
                    setSelectedContact(null);
                  }}
                />
                <Form.Check
                  type="radio"
                  label="Choose Existing Contact"
                  name="contactType"
                  value="existing"
                  checked={contactType === "existing"}
                  disabled={accountType === "new"}
                  onChange={() => {
                    setContactType("existing");
                    setContactFirstName("");
                    setContactLastName("");
                  }}
                />
              </div>

              {contactType === "new" && (
                <>
                  <Select
                    className="select2"
                    options={optionSalutation}
                    classNamePrefix="react-select"
                    value={optionSalutation.find(option => option.value === selectedSalutation) || null}
                    onChange={(selectedOption) => setSelectedSalutation(selectedOption?.value || null)}
                  />
                  <Form.Control
                    className="mt-2"
                    type="text"
                    placeholder="First Name"
                    value={contactFirstName}
                    onChange={(e) => setContactFirstName(e.target.value)}
                    required
                  />
                  <Form.Control
                    className="mt-2"
                    type="text"
                    placeholder="Last Name"
                    value={contactLastName}
                    onChange={(e) => setContactLastName(e.target.value)}
                    required
                  />
                </>
              )}

              {contactType === "existing" && (
                <Select
                  options={contactOptions}
                  isSearchable
                  value={selectedContact}
                  onChange={(option) => setSelectedContact(option)}
                />
              )}
            </Form.Group>

            {/* Opportunity Selection */}
            <Form.Group className="mb-3">
              <Form.Label>Opportunity</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  label="Create New Opportunity"
                  name="opportunityType"
                  value="new"
                  checked={opportunityType === "new"}
                  disabled={accountType === "new"}
                  onChange={() => {
                    setOpportunityType("new");
                    setOpportunityName(lead?.company || "N/A");
                    setSelectedOpportunity(null);
                  }}
                />
                <Form.Check
                  type="radio"
                  label="Choose Existing Opportunity"
                  name="opportunityType"
                  value="existing"
                  checked={opportunityType === "existing"}
                  disabled={accountType === "new"}
                  onChange={() => {
                    setOpportunityType("existing");
                    setOpportunityName(lead?.company || "N/A");
                  }}
                />
              </div>

              {opportunityType === "new" && (
                <Form.Control
                  className="mt-2"
                  type="text"
                  placeholder="Enter Opportunity Name"
                  value={opportunityName}
                  onChange={(e) => setOpportunityName(e.target.value)}
                  required
                />
              )}

              {opportunityType === "existing" && (
                <Select
                  options={opportunityOptions}
                  isSearchable
                  value={selectedOpportunity}
                  onChange={(option) => setSelectedOpportunity(option)}
                />
              )}
            </Form.Group>

            {/* Converted Status */}
            <Form.Group className="mb-3">
              <Form.Label>Converted Status</Form.Label>
              <Form.Control
                type="text"
                readOnly
                value={
                  statusOptions.find((status) => status.order === maxorder)?.name ||
                  "No Status"
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConvertLead}>Convert</Button>
        </Modal.Footer>
      </Modal>
      <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
      {/* /Convert Lead Modal */}
      {/* Success Contact */}
      <div className="modal custom-modal fade" id="success_mail" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-mail-opened" />
                </div>
                <h3>Email Connected Successfully!!!</h3>
                <p>
                  Email Account is configured with “example@example.com”. Now
                  you can access email.
                </p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to={route.companyDetails} className="btn btn-primary">
                    Go to email
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Success Contact */}
      {/* Add Contact */}
      <div className="modal custom-modal fade" id="add_contact" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Contact</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-2 icon-form">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                </div>
                <div className="access-wrap">
                  <ul>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-19.jpg" alt="" />
                          <Link to="#">Darlee Robertson</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-20.jpg" alt="" />
                          <Link to="#">Sharon Roy</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-21.jpg" alt="" />
                          <Link to="#">Vaughan</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-01.jpg" alt="" />
                          <Link to="#">Jessica</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-16.jpg" alt="" />
                          <Link to="#">Carol Thomas</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-22.jpg" alt="" />
                          <Link to="#">Dawn Mercha</Link>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Contact */}
      {/* Add Owner */}
      <div className="modal custom-modal fade" id="owner" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Deal Owner</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-2 icon-form">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                </div>
                <div className="access-wrap">
                  <ul>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" defaultChecked />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-19.jpg" alt="" />
                          <Link to="#">Darlee Robertson</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-20.jpg" alt="" />
                          <Link to="#">Sharon Roy</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-21.jpg" alt="" />
                          <Link to="#">Vaughan</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-01.jpg" alt="" />
                          <Link to="#">Jessica</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-16.jpg" alt="" />
                          <Link to="#">Carol Thomas</Link>
                        </span>
                      </label>
                    </li>
                    <li className="select-people-checkbox">
                      <label className="checkboxs">
                        <input type="checkbox" />
                        <span className="checkmarks" />
                        <span className="people-profile">
                          <ImageWithBasePath src="assets/img/profiles/avatar-22.jpg" alt="" />
                          <Link to="#">Dawn Mercha</Link>
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Owner */}
      {/* Deal Status */}
      <div className="modal custom-modal fade" id="deal_status" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Deal Status</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    className="select2"
                    classNamePrefix="react-select"
                    // options={status}
                    placeholder="Choose"
                  />
                </div>
                <div className="mb-3">
                  <label className="col-form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <textarea className="form-control" rows={5} defaultValue={""} />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Deal Status */}
      {/* Add New Stage */}
      <div className="modal custom-modal fade" id="add_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add New Stage */}
      {/* Create Pipeline */}
      <div className="modal custom-modal fade" id="create_pipeline" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon bg-light-blue">
                  <i className="ti ti-building" />
                </div>
                <h3>Pipeline Created Successfully!!!</h3>
                <p>View the details of pipeline, created</p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <Link to={route.dealsDetails} className="btn btn-primary">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Create Pipeline*/}
      {/* Edit Stage */}
      <div className="modal custom-modal fade" id="edit_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue="Inpipeline"
                  />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Stage */}
      {/* Delete Stage */}
      <Modal show={openModal} onHide={() => setOpenModal(false)}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove Stage?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> stage you selected.
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
              <Link to={route.contactList} className="btn btn-danger">
                Yes, Delete it
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      {/* /Delete Stage */}
      {/* Delete Price Book Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">Remove Event ?</h4>
            <p className="mb-0">
              Are you sure you want to remove <br /> this event?
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
              <button className="btn btn-light me-2" onClick={() => setShowDeleteModal(false)}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleDeleteEventConfirm}>
                Yes, Delete it
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <ResponseModal show={showMessageModal} onClose={() => setShowMessageModal(false)} response={response} />
    </>
  );
};

export default LeadsDetails;